import React, { createRef, useContext, createContext, useState, useEffect, useRef, type FC, Fragment, type ReactNode } from 'react';
import usePopup, { I_usePopup, type AP_modal } from "../aio-popup";
import * as UT from '../aio-utils';
import AIODate, { type I_dateObject, type I_dateUnit } from '../aio-date';
import { $, successSound, errorSound, BrowserMultiFormatReader, Result, type IScannerControls } from 'aio-deps';
import { useCanvas, type I_canvas_item } from '../aio-canvas';
import { type I_Range,AIOSlider,AIOSpinner } from '../aio-range';
import { GetSvg } from '../aio-utils';
import './index.css';
// #region main
type AI_context = {
    rootProps: I_AIOInput,
    popup: I_usePopup,
    showPassword: boolean,
    setShowPassword: (v?: boolean) => void,
    datauniqid: string,
    touch: boolean,
    click: (e: any) => void,
    optionClick: (option: AI_optionDetail, p?: any) => void,
    tagClick: (optionDetail: AI_optionDetail, isRemove?: boolean) => void,
    types: AI_types,
    DATE: AIODate,
    optionDetails: AI_optionDetails,
    error?: string,
    changable: boolean,
    AIChange: (a: any, b: any) => void,
    dateValueDetails: AI_dateDetail[],
    dateHook: ReturnType<typeof useDate>,
    optionsHook: ReturnType<typeof useOptions>,
    isDraggable: () => boolean,
    setInputFocused: (v: boolean) => void,
    openPopover: () => void,
    mainRef:any,
    keyboardNavHook: ReturnType<typeof useKeyboardNav>
}
const Context = createContext<AI_context>({} as any);
const Provider: FC<{ value: AI_context, children: ReactNode }> = ({ value, children }) => {
    return (<Context.Provider value={value}>{children}</Context.Provider>)
}
const useProvider = () => useContext(Context)
const AIOInput = (p: I_AIOInput) => {
    const props = { ...p }
    if (props.type === 'text') {
        if (typeof props.value !== 'string') { props.value = '' }

    }
    else if (props.type === 'number') { if (typeof props.value !== 'number') { props.value = undefined } }
    else if (props.type === 'panels') { props.deSelect = true }
    else if (props.type === 'tree') { if (props.size === undefined) { props.size = 36 } }
    if (props.type === 'file') {
        if (props.placeholder === undefined && props.text === undefined && props.multiple) { props.text = 'Select Files' }
        props.deSelect = props.deSelect !== false ? true : false
    }
    else if (props.type === 'select' && !props.text && props.multiple) {
        props.text = 'Select Items'
    }
    else if (props.type === 'date') {
        if (props.multiple) { props.text = props.text || `Select Dates` }
    }
    else if (props.type === 'time') {
        if (props.multiple) { props.text = props.text || `Select Times` }
    }
    if (props.type === 'text' && (props.options || props.fetchSuggestions) && !props.isSuggestion) { return <SuggestionInput {...props} /> }
    if (props.type === "custom") { return null }
    return <AIOINPUT {...props} />
}
export default AIOInput

const AIOINPUT = (props: I_AIOInput) => {
    const propsRef = useRef<I_AIOInput>(props)
    propsRef.current = props;
    let [types] = useState<AI_types>(getTypes(props))
    let [DATE] = useState<AIODate>(new AIODate())
    let { type, value, attrs = {}, rtl } = props;
    const changable = !!props.onChange && props.disabled !== true
    let [parentDom] = useState<any>(createRef())
    const isInputFocusedRef = useRef<boolean>(false)
    const setInputFocused = (v: boolean) => isInputFocusedRef.current = v
    const mainRef = useRef<any>(createRef())
    const modalRef = useRef<any>(createRef())
    let [datauniqid] = useState('aiobutton' + (Math.round(Math.random() * 10000000)))
    let popup = usePopup({ rtl: props.rtl })
    const optionsHook = useOptions()
    const keyboardNavHook = useKeyboardNav({
        rootProps: props,
        getOptionDetails: () => optionDetailsRef.current,
        getContainer: () => types.isDropdown ? modalRef.current : mainRef.current
    })
    const optionDetailsRef = useRef<AI_optionDetails>({ list: [], dic: {} })
    const dateHook = useDate(() => {
        return { ...props, type: props.type === 'date' ? 'date' : 'time' }
    });
    let [showPassword, SetShowPassword] = useState<boolean>(false);
    function setShowPassword(state?: boolean) { SetShowPassword(state === undefined ? !showPassword : state) }
    function getPopover() {
        let className = 'ai-border-radius-md';
        if (types.hasOption) { className += ' aio-input-dropdown' }
        const popover = (props.popover || {});
        let body = null;
        if (popover.body) { body = popover.body }
        else if (type === 'date') { body = <CalendarWraper onClose={closePopup} /> }
        else if (type === 'time') { body = <CalendarWraper onClose={closePopup} /> }
        else {
            if (optionDetailsRef.current.list.length === 0) { return }
            body = <Options />
        }
        const modalAttrs = UT.AddToAttrs({ ...popover.modalAttrs }, { className })
        let obj: AP_modal = {
            ...(props.popover || {}),
            isPopover:true,
            rtl: !!props.rtl,
            focus: !types.hasKeyboard,
            position: popover.position || 'popover',
            fitHorizontal: ['text', 'number', 'textarea'].indexOf(type) !== -1 || (type === 'select' && !!props.multiple) || !!popover.fitHorizontal,
            onClose: () => closePopup(),
            body,
            getTarget: () => {
                const res = $(mainRef.current).children('.aio-input')
                return res
            },
            modalAttrs,
            ref: modalRef
        }
        return obj;
    }
    function closePopup() {
        popup.removeModal();
        setTimeout(() => $(parentDom.current).focus(), 0)
    }
    function openPopover() {
        let open = !!popup.getModals().length
        if (open) { return }
        const popover = getPopover()
        if (!popover) { return }
        popup.addModal(popover);
    }
    function AIChange(a: any, b: any) {
        if (props.onChange) { props.onChange(a, b) }
    }
    function click(e: Event) {
        if (type === 'checkbox') { AIChange(!value, e) }
        else if (types.isDropdown) { openPopover() }
        else if (typeof props.onClick === 'function') { props.onClick(e) }
        else if (attrs.onClick) { attrs.onClick(); }
    }
    function optionClick(optionDetail: AI_optionDetail) {
        let { attrs = {}, onClick, close } = optionDetail;
        if (onClick) { onClick(optionDetail.optionOrg, optionDetail); }
        else if (attrs.onClick) { attrs.onClick(optionDetail); }
        else {
            if (types.isInput) { /*do nothing*/ }
            else if (type === 'tree') {/*do nothing*/ }
            else if (type === 'file') {/*do nothing*/ }
            else if (type === 'toggleButton') {
                let newIndex = optionDetail.index + 1;
                if (newIndex > optionDetailsRef.current.list.length - 1) { newIndex = 0 }
                const newOptionDetail = optionDetailsRef.current.list[newIndex];
                AIChange(newOptionDetail.value, newOptionDetail)
            }
            else if (types.isMultiple) {
                let { maxLength } = props, newValue;
                value = value || []
                if (value.indexOf(optionDetail.value) === -1) { newValue = value.concat(optionDetail.value) }
                else { newValue = value.filter((o: any) => o !== optionDetail.value) }
                while (!!maxLength && newValue.length > maxLength) {
                    newValue = newValue.slice(1, newValue.length)
                }
                AIChange(newValue, optionDetail)
            }
            else {
                if (optionDetail.value !== props.value) { AIChange(optionDetail.value, optionDetail) }
                else if (props.deSelect) {
                    if (type === 'radio' || type === 'tabs' || type === 'buttons' || type === 'panels') {
                        AIChange(undefined, optionDetail)
                    }
                }
            }
        }
        if (close) { closePopup() }
    }
    function tagClick(optionDetail: AI_optionDetail, isRemove?: boolean) {
        if (props.disabled === true || optionDetail.disabled === true) { return }
        const propsValue = props.value || []
        let newValue: any = []
        if (isRemove !== false) {
            if (props.type === 'tags') {
                newValue = propsValue.filter((rpv: any, i: number) => rpv !== undefined && i !== optionDetail.index)
            }
            else if (props.type === 'file') {
                if (props.multiple) {
                    newValue = propsValue.filter((rpv: any) => rpv.name !== optionDetail.value)
                }
                else { newValue = undefined }
            }
            else { newValue = propsValue.filter((rpv: any) => rpv !== optionDetail.value) }
            AIChange(newValue, optionDetail)
        }
        else if (optionDetail.tagAttrs?.onClick) {
            optionDetail.tagAttrs?.onClick(optionDetail)
        }
    }
    //inja kheili mohemme baraye inke chejoori option ha sakhte beshan type ha dastane khodeshoono daran baraye sakhtan option ha
    //tags options nadare pas value ro be onvane options dar nazar migire
    //date time options nadare pas dateDetails ro be onvane options dar nazar migire
    function getOptionDetails() {
        let optionOrgs: any[] = [];
        if (type === 'date' || type === 'time') {
            if (!props.multiple) { return { list: [], dic: {} } }
            optionOrgs = dateValueDetails.map((o) => ({ ...o }))
        }
        else if (type === 'file') {
            optionOrgs = getFileOptions(props.value)
        }
        else if (type === 'tags') {
            optionOrgs = props.value || []
        }
        else if (props.options) { optionOrgs = props.options }
        else { optionOrgs = []; }
        return optionsHook.getOptions({ rootProps: props, optionOrgs, optionProp: props.option || {} })
    }
    //use in mutiple date and time
    function getDateValueDetails(): AI_dateDetail[] {
        if (!props.multiple || !types.isDate) { return [] }
        const { value = [] } = props;
        let values: any[] = Array.isArray(value) ? [...value] : (value !== undefined ? [value] : [])
        return values.map((o) => dateHook.getDateDetails(o))
    }
    function getFileOptions(v: any) {
        const value: any[] = !v ? [] : (Array.isArray(v) ? v : [v])
        return value.map((file) => {
            let filename = file.name || 'untitle';
            let fileSize = file.size || 0;
            try {
                const minName = UT.Ellipsis(filename, 20, 'center');
                const sizeString = new UT.FileClass().SizeToString(fileSize)
                const tagBefore = <FileIcon file={file} key={file.name} />
                return { tagText: minName, tagSubtext: sizeString, tagBefore, value: filename }
            }
            catch { return { tagText: 'untitle' } }
        })
    }
    const isDraggable = () => types.hasOption && !!props.onSwap
    const render = () => {
        if (type === 'textlist') { return <TextList /> }
        if (type === 'toggleButton') { return <Input_ToggleButton /> }
        if (type === 'panels') { return <Panels /> }
        if (type === 'tree') { return <Input_Tree /> }
        if (type === 'list') { return <List /> }
        if (type === 'image') { return <Input_Image /> }
        return <AILayout />
    }
    useEffect(() => {
        if (props.isSuggestion && isInputFocusedRef.current) {
            const { options = [] } = props
            if (options.length) { openPopover() }
            else { closePopup() }
        }
    }, [props.isSuggestion ? props.options : undefined])
    if (!type) { return null }
    const dateValueDetails: AI_dateDetail[] = getDateValueDetails();
    optionDetailsRef.current = getOptionDetails()
    const renderPopup = () => {
        if (!types.isDropdown) { return null }
        if (props?.popover?.portal) { return popup.portal() }
        return popup.render()
    }
    const comp = render()
    return (
        <Provider value={{
            changable, AIChange, optionDetails: optionDetailsRef.current, popup, dateHook, optionsHook, tagClick, keyboardNavHook,
            rootProps: { ...props, value }, datauniqid, touch: 'ontouchstart' in document.documentElement, isDraggable, openPopover,
            click, optionClick, types, showPassword, setShowPassword, DATE, dateValueDetails, setInputFocused,mainRef
        }}>
            <div ref={mainRef} style={{ display: 'contents' }}>
                <TagsLayout>{comp}</TagsLayout>
            </div>
            {renderPopup()}
        </Provider>
    )
}
// #endregion main
// #region types
function getTypes(props: I_AIOInput): AI_types {
    function isDropdown() {
        if (['select', 'date', 'time'].indexOf(type) !== -1) { return true }
        if (['text', 'number', 'textarea'].indexOf(type) !== -1 && props.options) { return true }
        if (type === 'button' && props.popover) { return true }
        return false
    }
    let { type, multiple } = props;
    let isMultiple;
    if (type === 'tags') { isMultiple = true }
    else if (['radio', 'range', 'file', 'image', 'buttons', 'select', 'date', 'time', 'panels', 'tabs'].indexOf(type) !== -1) { isMultiple = !!multiple }
    else { isMultiple = false };
    return {
        isDate: ['date', 'time'].indexOf(type) !== -1,
        isMultiple,
        isInput: ['text', 'number', 'textarea', 'password', 'color'].indexOf(type) !== -1,
        isDropdown: isDropdown(),
        hasOption: ['text', 'number', 'textarea', 'color', 'select', 'radio', 'tabs', 'list', 'buttons', 'tags'].indexOf(type) !== -1,
        isRootOptions: ['radio', 'tabs', 'buttons', 'tags'].indexOf(type) !== -1,
        ai_height: ['text', 'number', 'password', 'color', 'select', 'date', 'time', 'checkbox', 'file', 'tabs','slider'].indexOf(type) !== -1,
        hasPlaceholder: ['text', 'number', 'textarea', 'color', 'select', 'image', 'date', 'time'].indexOf(type) !== -1,
        hasKeyboard: ['text', 'textarea', 'number', 'password'].indexOf(type) !== -1,
        hasText: ['checkbox', 'button', 'select'].indexOf(type) !== -1,
        hasSearch: ['select'].indexOf(type) !== -1,
        hasTags: ['date', 'time', 'select', 'file'].indexOf(type) !== -1,
        hasInlineDeSelect: ['text', 'number', 'date', 'time', 'select', 'file'].indexOf(type) !== -1
    }
}

export type I_AIOInput =
    AI_isRange & AI_isTree & AI_isDate & {
        after?: ReactNode, before?: ReactNode,
        attrs?: any, className?: string, style?: any, disabled?: boolean, rtl?: boolean,
        imageAttrs?: any,
        justify?: boolean,
        calc?: boolean,
        value?: any,
        onChange?: (newValue: any, p?: any) => Promise<any> | any,
        deSelect?: boolean,
        onSubmit?: (newValue: any, p?: any) => Promise<any> | any,
        placeholder?: ReactNode, text?: ReactNode, subtext?: ReactNode,
        type: AI_type,
        validations?: (any[]) | ((v: any) => string | undefined),
        checkIcon?: ReactNode[],
        listOptions?: { decay?: number, stop?: number, count?: number, move?: any, editable?: boolean },//list
        onClick?: (e: Event) => void,//button
        preview?: boolean,//password,image,file
        tagSearch?: string, hideTags?: boolean,//select
        isSuggestion?: boolean,
        fetchSuggestions?: (search: string) => Promise<any[]>,
        maskPattern?: {
            type: 'text' | 'number' | 'select', length?: number, options?: 'fa-plate' | string[], html?: ReactNode,flex?:number,
            def?: string, after?: ReactNode, placeholder?: string, disabled?: boolean, attrs?: any, style?: any, className?: string
        }[],
        optionsPlaceholder?: ReactNode,
        switchOptions?: {
            textOn?: ReactNode, textOff?: ReactNode, textButton?: ReactNode,
            size?: number, groove?: boolean, width?: number,
            attrs?: any,
            buttonAttrs?:any
        },
        caret?: boolean | ReactNode,
        popover?: {
            portal?: boolean,
            body?: ReactNode, fitHorizontal?: boolean,
            backdropAttrs?: any, modalAttrs?: any, headerAttrs?: any, bodyAttrs?: any, footerAttrs?: any,
            footer?: any
            position?: 'center' | 'left' | 'right' | 'top' | 'bottom' | 'fullscreen', limitTo?: string,
            header?: {
                html?: ((p: { removeModal: () => void, state: any, setState: any }) => ReactNode),
                title?: string, subtitle?: string, before?: ReactNode, after?: ReactNode,
                onClose?: boolean | ((p: { state: any, setState: (state: any) => void }) => void),
            }
        },
        open?: boolean,
        blurChange?: boolean, filter?: string[], inputAttrs?: any, swip?: number, spin?: boolean, autoHighlight?: boolean, delay?: number, voice?: 'en' | 'fa',
        multiple?: boolean,
        maxLength?: number,
        onSwap?: true | ((newOptions: any[], fromIndex: number, toIndex: number) => void),
        optionsAttrs?: any,
        option?: AI_optionProp,
        options?: any[], search?: string,
        debugKey?: string
    }
export type AI_props<T extends keyof I_AIOInput> = NonNullable<I_AIOInput[T]>;
export type AI_optionProp = { [key in keyof AI_optionDetail]?: (optionOrg: any, optionDetail: AI_optionDetail) => any }
export type AI_optionDetails = { list: AI_optionDetail[], dic: { [key: string]: AI_optionDetail } }
export type AI_type = 'text' | 'number' | 'textarea' | 'password' | 'select' | 'tree' | 'spinner' | 'slider' | 'tags' | 'toggleButton' | 'textlist' |
    'button' | 'date' | 'color' | 'radio' | 'tabs' | 'list' | 'image' | 'file' | 'checkbox' | 'time' | 'buttons' | 'panels' | 'mask' |
    'custom'
export type AI_date_trans = 'Today' | 'Clear' | 'Today' | 'This Month' | 'Select Year'
type AI_types = {
    isDate: boolean, isMultiple: boolean, isInput: boolean, isDropdown: boolean, hasOption: boolean, ai_height: boolean, hasTags: boolean, isRootOptions: boolean,
    hasPlaceholder: boolean, hasKeyboard: boolean, hasText: boolean, hasSearch: boolean, hasInlineDeSelect: boolean
}
export type AI_Popover_props = { getRootProps: () => I_AIOInput, id: string, toggle: (popover: any) => void, types: AI_types }
type AI_isDate = Omit<I_Calendar, 'type' | 'onChange' | 'value'>
type AI_isRange = Omit<I_Range, 'type' | 'onChange'>
type AI_isTree = Omit<AI_Tree, 'onChange' | 'type' | 'value'>

export type AI<AI_type, T> = Omit<I_AIOInput, 'onChange' | 'type'> & {
    onChange?: AI_onChange<AI_type, T>,
}
type AI_onChange<AI_type, T> =
    AI_type extends 'toggleButton' ? (v: any) => void :
    AI_type extends 'textlist' ? (v: string[]) => void :
    AI_type extends 'text' ? (v: string, option?: any) => void :
    AI_type extends 'number' ? (v: number | undefined) => void :
    AI_type extends 'textarea' ? (v: string) => void :
    AI_type extends 'mask' ? (value: string[]) => void :
    AI_type extends 'password' ? (v: string) => void :
    AI_type extends 'color' ? (v: string) => void :
    AI_type extends 'select' ? (v: T, optionDetail: AI_optionDetail) => void :
    AI_type extends 'radio' ? (v: T, optionDetail: AI_optionDetail) => void :
    AI_type extends 'tabs' ? (v: T, optionDetail: AI_optionDetail) => void :
    AI_type extends 'buttons' ? (v: T, optionDetail: AI_optionDetail) => void :
    AI_type extends 'tags' ? (v: T[]) => void :
    AI_type extends 'tree' ? (v: T[]) => void :
    AI_type extends 'image' ? (url: any, file: any) => void :
    AI_type extends 'file' ? (newFile: File | undefined) => void :
    AI_type extends 'checkbox' ? (v: boolean) => void :
    AI_type extends 'date' ? (newDate: T, dateDetail: AI_dateDetail) => void :
    AI_type extends 'time' ? (time: T, dateDetail: AI_dateDetail) => void :
    AI_type extends 'slider' ? (newValue: number) => void :
    AI_type extends 'spinner' ? (newValue: number) => void :
    AI_type extends 'panels' ? (newValue: T) => void :
    AI_type extends 'list' ? (v: T, optionDetail: AI_optionDetail) => void :
    never;
export const AIMask: FC<AI<'mask', any>> = (props) => <AIOInput {...props} type='mask' />
export const AITextList: FC<AI<'textlist', any>> = (props) => <AIOInput {...props} type='textlist' />
export const AIText: FC<AI<'text', any>> = (props) => <AIOInput {...props} type='text' />
export const AINumber: FC<AI<'number', any>> = (props) => <AIOInput {...props} type='number' />
export const AITextarea: FC<AI<'textarea', any>> = (props) => <AIOInput {...props} type='textarea' />
export const AIPassword: FC<AI<'password', any>> = (props) => <AIOInput {...props} type='password' />
export const AIColor: FC<AI<'color', any>> = (props) => <AIOInput {...props} type='color' />
export const AIToggleButton: FC<AI<'toggleButton', any>> = (props) => <AIOInput {...props} type='toggleButton' />
export const AISelect: FC<AI<'select', any>> = (props) => <AIOInput {...props} type='select' />
export const AIRadio: FC<AI<'radio', any>> = (props) => <AIOInput {...props} type='radio' />
export const AITabs: FC<AI<'tabs', any>> = (props) => <AIOInput {...props} type='tabs' />
export const AIButtons: FC<AI<'buttons', any>> = (props) => <AIOInput {...props} type='buttons' />
export const AITags: FC<AI<'tags', any>> = (props) => <AIOInput {...props} type='tags' />
export const AITree: FC<AI<'tree', any>> = (props) => <AIOInput {...props} type='tree' />
export const AIImage: FC<AI<'image', any>> = (props) => <AIOInput {...props} type='image' />
export const AIFile: FC<AI<'file', any>> = (props) => <AIOInput {...props} type='file' />
export const AICheckbox: FC<AI<'checkbox', boolean>> = (props) => <AIOInput {...props} type='checkbox' />
export const AIDate: FC<AI<'date', any>> = (props) => <AIOInput {...props} type='date' />
export const AITime: FC<AI<'time', any>> = (props) => <AIOInput {...props} type='time' />
export const AIPanels: FC<AI<'panels', any>> = (props) => <AIOInput {...props} type='panels' />
export const AIList: FC<AI<'list', any>> = (props) => <AIOInput {...props} type='list' />
export const AISlider: FC<AI<'slider', number>> = (props) => <AIOInput {...props} type='slider' />
export const AISpinner: FC<AI<'spinner', number>> = (props) => <AIOInput {...props} type='spinner' />
// #endregion types
// #region layout
const useLayout = () => {
    const { rootProps, click, optionClick, types, changable, AIChange, showPassword, setShowPassword, touch, datauniqid, popup, isDraggable, optionDetails, dateHook } = useProvider()
    const getCheckbox = (optionDetail?: AI_optionDetail) => {
        const { multiple, type, checkIcon } = rootProps;
        const hasCheckbox = !!optionDetail ? typeof optionDetail.checked === 'boolean' : rootProps.type === 'checkbox'
        if (!hasCheckbox) { return null }
        const checked = !!optionDetail ? optionDetail.checked : !!rootProps.value
        if (rootProps.switchOptions) {
            return <Switch value={rootProps.value} switchOptions={rootProps.switchOptions} />
        }
        return (<CheckIcon round={!multiple && type === 'radio'} checked={checked} checkIcon={optionDetail ? optionDetail.checkIcon : checkIcon} />)
    }
    const getDragIcon = (optionDetail?: AI_optionDetail) => {
        if (!isDraggable() || !optionDetail) { return null }
        const d = "M9,3H11V5H9V3M13,3H15V5H13V3M9,7H11V9H9V7M13,7H15V9H13V7M9,11H11V13H9V11M13,11H15V13H13V11M9,15H11V17H9V15M13,15H15V17H13V15M9,19H11V21H9V19M13,19H15V21H13V19Z";
        return (<svg viewBox="8 4 10 13" role="presentation" style={{ width: 12, height: '1.8rem' }}><path d={d} style={{ fill: 'currentcolor' }}></path></svg>)
    }
    const getBefore = (optionDetail?: AI_optionDetail, indent?: ReactNode) => {
        const before = optionDetail ? optionDetail?.before : rootProps.before;
        const dragIcon = getDragIcon(optionDetail)
        const Indent = (!!indent && indent !== null) ? indent : null
        const Checkbox = getCheckbox(optionDetail)
        const FileIconNode = rootProps.type === 'file' && !rootProps.multiple && !!rootProps.value ? <FileIcon file={rootProps.value} /> : null
        const res = [
            dragIcon,
            Indent,
            Checkbox,
            before,
            FileIconNode
        ].filter((o) => o !== undefined && o !== null && !!o)
        if (!res.length) { return null }
        return <div className="aio-input-before">{res.map((o, i) => <Fragment key={'layoutbefore' + i}>{o}</Fragment>)}</div>
    }
    const getAfter = (optionDetail?: AI_optionDetail) => {
        const after = optionDetail ? optionDetail?.after : rootProps.after;
        const hasDeselect = !rootProps.multiple && !!rootProps.deSelect && types.hasInlineDeSelect && !optionDetail && !!changable && rootProps.value !== undefined && rootProps.value !== null && rootProps.value !== ''
        const hasPreview = !!rootProps.preview && !optionDetail && !!changable && rootProps.type === 'password'
        const hasCalc = !!rootProps.calc && rootProps.type === 'number' && !optionDetail && !!changable
        function getCaret() {
            if (!types.isDropdown || optionDetail || (types.isInput && !rootProps.options)) { return null }
            let { caret } = rootProps;
            if (caret === false) { return null }
            return <div className='aio-input-caret'>{caret === undefined ? new UT.GetSvg('em').getIcon('mdiChevronDown', .8) : caret}</div>
        }
        const res = [
            after,
            hasDeselect ? <div key={`afterdeselect`} className='aio-input-deSelect' onClick={(e) => {
                e.stopPropagation(); e.preventDefault(); AIChange(undefined, undefined)
            }}>{new UT.GetSvg('em').getIcon('mdiClose', .8)}</div> : null,
            hasPreview ? <div key={`afterpreview`} className='aio-input-password-preview' onClick={() => setShowPassword()}>{new UT.GetSvg('em').getIcon(showPassword ? 'mdiEyeOff' : 'mdiEye', .8)}</div> : null,
            getCaret()
        ].filter((o) => o !== undefined && o !== null)
        if (!res.length) { return null }
        return <>{res.map((o, i) => <div key={'layoutafter' + i} className="aio-input-after">{o}</div>)}</>
    }

    const getClassName = (optionDetail?: AI_optionDetail) => {
        const { type, rtl, vertical, multiple } = rootProps;
        const disabled = rootProps.disabled || optionDetail?.disabled;
        const res = []
        if (optionDetail) {
            if (optionDetail.className) { res.push(optionDetail.className) }
            res.push(`aio-input-option aio-input-${type}-option ai-padding-md ai-padding-h`)
            if(!types.isDropdown){res.push(`ai-border-radius-md`)}
            if (type === 'tree') { res.push('auto-height') }
            else { res.push('ai-height') }
            if (types.isDropdown) { res.push(`aio-input-dropdown-option`) }
            if (optionDetail.active === true) {
                res.push('active')
                if (type === 'tabs') { res.push('aio-input-active-color') }
                if (type === 'buttons') { res.push('aio-input-active-bgcolor') }
                if (type === 'select' && !multiple) { res.push('aio-input-active-bgcolor') }
            }
            if (optionDetail.justify === true) { res.push('aio-input-option-justify') }
        }
        else {
            if (rootProps.className) { res.push(rootProps.className) }
            res.push(`aio-input`)
            if (['radio', 'buttons', 'tabs'].indexOf(rootProps.type) === -1) { res.push(`ai-padding-md`) }
            res.push('ai-border-radius-md')
            res.push(`aio-input-${type}`)
            if (touch) { res.push('aio-input-touch') }
            if (types.isInput) { res.push(`aio-input-input`) }
            if (type === 'select' && rootProps.multiple && !rootProps.hideTags) { res.push('aio-input-multiselect') }
            if (types.ai_height) { res.push(`ai-height ai-padding-h`) }
            if (rootProps.justify) { res.push('aio-input-justify') }
            res.push(rtl ? 'aio-input-rtl' : 'aio-input-ltr')
            if (!!popup.getModals().length && ['text', 'number', 'textarea'].indexOf(type) !== -1) { res.push('z-index-input') }
            if (type === 'slider') {
                if (vertical) { res.push('aio-input-slider-vertical') }
                else { res.push('aio-input-slider-horizontal') }
            }
        }
        if (disabled === true) { res.push('disabled') }
        if (datauniqid) { res.push(datauniqid) }
        res.push('aio-input-focus')
        return res.join(' ')
    }
    const getStyle = (optionDetail?: AI_optionDetail) => {
        const style = (optionDetail ? optionDetail?.style : rootProps.style) || {}
        if (rootProps.type === 'list' && optionDetail) { style.height = rootProps.size || 36 }
        return style
    }
    const onKeyDown = (e: any) => {
        const code = e.keyCode;
        if (code === 13) { click(e) }
    }
    const getAttrs = (optionDetail?: AI_optionDetail) => {
        const disabled = rootProps.disabled || optionDetail?.disabled;
        return UT.AddToAttrs(
            optionDetail?.attrs || rootProps.attrs,
            {
                className: getClassName(optionDetail),
                style: getStyle(optionDetail),
                attrs: {
                    onClick: disabled === true ? undefined : (e: any) => {
                        e.stopPropagation();
                        if (optionDetail) { optionClick(optionDetail) }
                        else { click(e) }
                    },
                    "data-index": optionDetail?.index,
                    onKeyDown: (e: any) => onKeyDown(e),
                    tabIndex: optionDetail ? 0 : types.isRootOptions?undefined:1
                }
            }
        )
    }
    const getText = (optionDetail?: AI_optionDetail) => {
        const { type } = rootProps;
        if (optionDetail) { return optionDetail.text }
        else {
            if (types.isInput) { return <Input /> }
            if (types.isRootOptions) { return <Options /> }
            if (type === "mask") { return <AIMaskComponent /> }
            if (type === "slider") { return <AIOSlider {...rootProps} /> }
            if (type === "spinner") { return <AIOSpinner {...rootProps} /> }
            if (type === 'date' || type === 'time') { return <div style={{ direction: 'ltr', width: 'fit-content' }}>{dateHook.getDateText(rootProps.value, true)}</div> }
            if (type === 'tags') { return <TagOptions /> }
            if (type === 'select') {
                if (rootProps.text !== undefined) { return rootProps.text }
                if (!rootProps.multiple) {
                    if (rootProps.value !== null && rootProps.value !== undefined) {
                        const option = optionDetails.dic[`a${rootProps.value}`]
                        if (option) { return option.text }
                    }
                }
                return null
            }
            if (type === 'file') {
                if (!!rootProps.value) {
                    try { return rootProps.value.name } catch { }
                }
            }
            return rootProps.text
        }
    }
    const getSubtext = (optionDetail?: AI_optionDetail) => {
        return optionDetail ? optionDetail.subtext : rootProps.subtext
    }
    const getHtml = () => {
        if (rootProps.type === 'file') { return <InputFile /> }
        if (rootProps.type === 'tabs') { return <div className='aio-input-tabs-option-bar'></div> }
    }
    return { getText, getSubtext, getBefore, getAfter, getAttrs, getHtml }
}
const AILayout: FC<{ optionDetail?: AI_optionDetail, indent?: ReactNode }> = (props) => {
    const { optionDetail, indent } = props;
    const { rootProps } = useProvider()
    const layout = useLayout();
    const getValueClassName = () => {
        const type = rootProps.type
        if (!optionDetail) { return `aio-input-${type}-value` }
        else { return `aio-input-${type}-option-value` }
    }
    return (
        <Layout
            html={layout.getHtml()}
            text={layout.getText(optionDetail)}
            subtext={layout.getSubtext(optionDetail)}
            before={layout.getBefore(optionDetail, indent)}
            after={layout.getAfter(optionDetail)}
            attrs={layout.getAttrs(optionDetail)}
            placeholder={!optionDetail ? rootProps.placeholder : undefined}
            valueClassName={getValueClassName()}
            justify={optionDetail ? optionDetail.justify : rootProps.justify}
        />
    )
}
const Layout: FC<{
    valueClassName?: string
    attrs?: any,
    html?: ReactNode, before?: ReactNode, after?: ReactNode, subtext?: ReactNode,
    text: ReactNode, placeholder?: ReactNode,
    justify?: boolean,
    valueAttrs?: any,
}> = (props) => {
    let { html, before, after, attrs, text, placeholder, justify, subtext, valueClassName } = props;
    function cls() {
        let className = `aio-input-value`;
        if (valueClassName) { className += ` ${valueClassName}` }
        return className;
    }
    function Text(): ReactNode {
        const hasText = text !== null && text !== undefined
        const hasPlaceholder = placeholder !== undefined && placeholder !== null
        if (hasText) {
            const className = `${cls()}${justify ? ' aio-input-value-justify' : ''}${!!subtext ? ' aio-input-has-subtext' : ''}`
            return <div className={className} data-subtext={subtext}>{text}</div>
        }
        if (hasPlaceholder) { return <div className='aio-input-placeholder'>{placeholder}</div> }
        if(after !== undefined && after !== null){
            return <div style={{ flex: 1 }}></div>
        }
        return null
    }
    let content = (<>
        {before !== undefined && before}
        {Text()}
        {after !== undefined && after}
        {html !== undefined && html}
    </>)
    return (<label {...attrs}>{content}</label>)
}

const TagsLayout: FC<{ children: ReactNode }> = ({ children }) => {
    let { rootProps, optionDetails, types } = useProvider();
    if (!types.hasTags) { return children }
    const { type, value, multiple, hideTags } = rootProps
    if (!multiple || hideTags) { return children }
    const getTagOptionDetails = () => {
        if (type === 'select') {
            let values: any[] = Array.isArray(value) ? [...value] : (value !== undefined ? [value] : [])
            if (!values.length) { return [] }
            return values.map((o) => optionDetails.dic['a' + o])
        }
        if (type === 'date' || type === 'time' || type === 'file') { return optionDetails.list }
        return []
    }
    const tagOptionDetails = getTagOptionDetails();
    if (!tagOptionDetails.length) { return children }
    return <div className={'aio-input-multiselect-container'}>{children}<TagOptions optionDetails={getTagOptionDetails()} /></div>
}
const TagOptions: FC<{ optionDetails?: AI_optionDetail[] }> = (props) => {
    let { rootProps, optionDetails } = useProvider();
    const list = props.optionDetails || optionDetails.list
    if (!list.length) { return null }
    let renderOptions = list.map((optionDetail: AI_optionDetail, i) => <TagLayout optionDetail={optionDetail} key={i} />);
    const attrs = UT.AddToAttrs(
        rootProps.optionsAttrs, {
        className: [
            'aio-input-options',
            'ai-border-radius-md',
            'aio-input-tag-options ai-padding-sm',
            rootProps.justify ? 'aio-input-dropdown-options' : undefined
        ]
    })
    return (<div {...attrs}>{renderOptions}</div>)
}
const TagLayout: FC<{ optionDetail: AI_optionDetail }> = ({ optionDetail }) => {
    const { rootProps, changable, tagClick } = useProvider()
    const { tagBefore = new UT.GetSvg('em').getIcon('mdiCircleMedium', 0.7), tagAfter } = optionDetail
    const disabled = !!rootProps.disabled || !!optionDetail.disabled;
    const getAfter = () => {
        const after = tagAfter === undefined ? null : (tagAfter)
        const removeIcon = !changable ? null : (
            <div
                className={`aio-input-tag-icon aio-input-tag-remove`}
                onClick={(e) => { e.stopPropagation(); tagClick(optionDetail as AI_optionDetail, true) }}
            >{new UT.GetSvg('em').getIcon('mdiClose', 0.7)}</div>
        )
        if (after === null && removeIcon === null) { return null }
        return (<>
            <div className="aio-input-after">{after}</div>
            <div className="aio-input-after">{removeIcon}</div>
        </>)
    }
    const getClassName = () => {
        const { type } = rootProps;
        const res = []
        res.push(`aio-input-tag ai-padding-sm ai-border-radius-sm aio-input-${type}-tag`)
        res.push('aio-input-active-bgcolor')
        if (disabled === true) { res.push('disabled') }
        return res.join(' ')
    }
    const getAttrs = () => {
        const disabled = !!rootProps.disabled || !!optionDetail.disabled;
        return UT.AddToAttrs(
            optionDetail.tagAttrs,
            {
                className: getClassName(),
                attrs: {
                    onClick: (e: any) => { if (disabled) { return } e.stopPropagation(); tagClick(optionDetail, false) },
                    "data-index": optionDetail.index
                }
            }
        )
    }
    return (
        <Layout
            valueClassName='aio-input-tag-option-value'
            text={optionDetail.tagText || optionDetail.text}
            subtext={optionDetail.tagSubtext}
            before={<div className="aio-input-before">{tagBefore}</div>}
            after={getAfter()}
            attrs={getAttrs()}
        />
    )
}
const Input_Tree: FC = () => {
    const { rootProps } = useProvider();
    return <AITreeComponent {...{ ...rootProps, value: rootProps.value || [] }} />
}
const Input_ToggleButton: FC = () => {
    const { optionDetails, rootProps } = useProvider();
    let option = optionDetails.list.find((o) => o.value === rootProps.value) || optionDetails.list[0]
    return !option ? null : <AILayout optionDetail={option} />
}
export const CheckIcon: FC<{
    checkIcon?: ReactNode[],
    checked?: boolean,
    round?: boolean,
}> = (props) => {
    if (props.checked === undefined) { return null }
    if (Array.isArray(props.checkIcon)) { return <>{props.checkIcon[props.checked === false ? 0 : 1] || null}</> }
    return (
        <div className={'aio-input-check-out aio-input-active-color' + (props.checked ? ' checked' : '') + (props.round ? ' aio-input-check-round' : '')} style={{ background: 'none' }}>
            <div className='aio-input-active-bg aio-input-check-in'></div>
        </div>
    );
}
const Switch: FC<{ value: boolean, switchOptions: I_AIOInput["switchOptions"] }> = ({ value = false, switchOptions = {} }) => {
    const { rootProps } = useProvider();
    const { onChange = () => { } } = rootProps
    const { textButton = null, textOff = null, textOn = null, groove, size, width } = switchOptions
    const attrs = UT.AddToAttrs(switchOptions.attrs, { className: ['aio-input-switch', !!value ? 'active' : ''], style: { fontSize: size, width }, attrs: { onClick: () => onChange(!value) } })
    const buttonAttrs = UT.AddToAttrs(switchOptions.buttonAttrs, {className: ['aio-input-switch-button', !!value ? 'active' : '']})
    return (
        <div {...attrs}>
            <div className="aio-input-switch-off-content">
                <div className="aio-input-switch-text">{textOff}</div>
            </div>
            <div className="aio-input-switch-on-content">
                <div className="aio-input-switch-text">{textOn}</div>
            </div>
            {!!groove && <div className="aio-input-switch-groove"></div>}
            <div {...buttonAttrs}>{textButton}</div>
        </div>
    )
}
// #endregion layout
// #region input
const Input: FC = () => {
    const { rootProps, types, showPassword, optionDetails, AIChange, changable, setInputFocused } = useProvider()
    const { type, delay = 100 } = rootProps;
    const { maxLength = Infinity, spin = true } = rootProps;
    let { filter = [] } = rootProps;
    let [dom] = useState<any>(createRef())
    let [temp] = useState<any>({ atimeout: undefined, btimeout: undefined, clicked: false })
    let [datauniqid] = useState(`ac${Math.round(Math.random() * 100000)}`)
    let [value, setValue] = useState<any>(rootProps.value || '');
    let valueRef = useRef(value);
    const getRef = () => {
        const { inputAttrs = {} } = rootProps;
        if (inputAttrs.ref) { return inputAttrs.ref }
        return dom
    }
    valueRef.current = value;
    function setSwip() {
        if (type === 'number' && rootProps.swip) {
            new UT.Swip({
                speedY: rootProps.swip * 0.2, reverseY: true, minY: rootProps.min, maxY: rootProps.max,
                stepY: rootProps.swip,
                dom: () => {
                    const ref = getRef();
                    if (ref !== null && ref.current !== null) {
                        const res = $(ref.current)
                        return res
                    }
                },
                start: () => {
                    let vref = +valueRef.current
                    vref = isNaN(vref) ? 0 : vref
                    return [0, vref]
                },
                move: (p: UT.I_Swip_parameter) => {
                    let { y } = p.change || { y: 0 };
                    if (rootProps.min !== undefined && y < rootProps.min) { y = rootProps.min; }
                    if (rootProps.max !== undefined && y > rootProps.max) { y = rootProps.max }
                    change(y)
                }
            })
        }
    }
    useEffect(() => { setSwip() }, [])
    function getValidValue() {
        let v = rootProps.value;
        if (type === 'number') {
            if (v === '') { return undefined }//important because +('') is 0
            else if (!isNaN(+v)) {
                v = +v;
                if (typeof rootProps.min === 'number' && v < rootProps.min) { v = rootProps.min }
                else if (typeof rootProps.max === 'number' && v > rootProps.max) { v = rootProps.max }
            }
        }
        return v
    }
    function update() {
        clearTimeout(temp.atimeout);
        temp.atimeout = setTimeout(() => {
            let v = getValidValue();
            if (v !== value) {
                setValue(v)
            }
        }, delay);
    }
    useEffect(() => { update() }, [rootProps.value])
    function change(value: any) {
        if (!changable) { return }
        if (!Array.isArray(filter)) { filter = [] }
        if (types.hasKeyboard) { value = UT.keyboard_filter(value, { maxLength, filter, toPersian: true }) }
        if (rootProps.type === 'number') {
            if (value === '') { value = undefined }
            else { value = +value }
        }
        setValue(value);
        if (!rootProps.blurChange) {
            clearTimeout(temp.btimeout);
            temp.btimeout = setTimeout(() => AIChange(value, undefined), delay);
        }
    }
    function click() {
        if (rootProps.autoHighlight === false) { return }
        if (temp.clicked) { return }
        temp.clicked = true;
        $(getRef().current).focus().select();
    }
    function blur() {
        temp.clicked = false
        setInputFocused(false)
        if (rootProps.blurChange && changable) { AIChange(value, undefined) }
    }
    function inputFocus() {
        setInputFocused(true)
    }
    function getInputAttrs() {
        let InputAttrs = UT.AddToAttrs(
            rootProps.inputAttrs,
            {
                className: !spin ? 'no-spin' : undefined,
                style: rootProps.justify ? { textAlign: 'center' } : undefined
            }
        )
        let p = {
            ...InputAttrs,
            ref: getRef(),
            value, type, disabled: rootProps.disabled, placeholder: rootProps.placeholder, list: rootProps.options ? datauniqid : undefined,
            onClick: () => click(),
            onChange: (e: any) => change(e.target.value),
            onBlur: () => blur(),
            onFocus: () => inputFocus()
        }
        if (type === 'password' && showPassword) { p = { ...p, type: 'text', style: { ...p.style, textAlign: 'center' } } }
        if (filter.length === 1 && filter[0] === 'number') {
            p.pattern = "\d*";
            p.inputMode = "numeric";
        }
        return p;
    }
    let attrs = getInputAttrs()
    if (type === 'color') {
        return (
            <label style={{ width: '100%', height: '100%', background: value }}>
                <input {...attrs} style={{ opacity: 0 }} />
                {!!optionDetails.list.length && <datalist id={datauniqid}>{optionDetails.list.map((o: AI_optionDetail) => <option value={o.value} />)}</datalist>}
            </label>
        )
    }
    else if (type === 'textarea') { return <textarea {...attrs} /> }
    else { return (<input {...attrs} />) }
}

// endregion input
// #endregion layout
// #region useForm
export type I_formInput = I_AIOInput & {
    field: string, customType?: string,
    tag?: string, required?: boolean, validation?: string[], label?: string, labelType?: 'inline' | 'online', labelAttrs?: any
}
export type I_formInputs = { [key: string]: I_formInput}
type I_wizardStep<T> = { id: string, show?: (data: T) => boolean, next?: () => Promise<boolean>, prev?: () => Promise<boolean>, nextText?: string, prevText?: string, disabled?: boolean }
export type I_useFormProps<T> = {
    inputs: I_formInputs,
    customTypes?: {[key: string]: (input: I_formInput & {value:any,onChange:(v:any)=>void}) => ReactNode},
    data: T, fa?: boolean; debug?: boolean, showErrors?: boolean, rtl?: boolean,
    fetchError?: { [field: string]: (value: any) => Promise<string | void> },
    wizard?: { steps: I_wizardStep<T>[] },
    onChange: (data: T, p: { field: string, value: any }) => void;
    onSubmit?: () => Promise<boolean | undefined | void>;
    submitText?: ((data: T) => ReactNode) | ReactNode;
    onClose?: () => void; closeText?: ((data: T) => ReactNode) | ReactNode;
    option?: { [key in keyof I_formInput]?: (p: { inputName: string, data: T, input: I_formInput }) => any },
    validations?: { [name: string]: (p: { data: T, inputName: string, value: any }) => string | void }
};
type I_formTag = 'fieldset' | 'section' | 'div' | 'p' | 'form';
export type I_formNode<T> = {
    debugId?: string, wizardId?: string, footer?: ReactNode, header?: ReactNode, panel?: ReactNode, panelAttrs?: any,name?:string,
    v?: I_formNode<T>[], h?: I_formNode<T>[], html?: ReactNode, input?: string,extendInput?:Partial<I_formInput>, attrs?: any, className?: string, style?: any, show?: boolean,
    customType?: string, deps?: string,
    flex?: number, scroll?: boolean, tag?: I_formTag, legend?: ReactNode, id?: string, isStatic?: boolean,
    align?: 'v' | 'h' | 'vh' | 'hv', hide_xs?: boolean, hide_sm?: boolean, hide_md?: boolean, hide_lg?: boolean, show_xs?: boolean, show_sm?: boolean, show_md?: boolean, show_lg?: boolean
}
type I_formNodeContext<T> = {
    wizardHook: ReturnType<typeof useWizard<T>>,
    nodeHook: ReturnType<typeof useNode>,
    inputHook: ReturnType<typeof useInput<T>>,
    errorHook: ReturnType<typeof useError<T>>,
    rootProps: I_useFormProps<T>
}
const FormNodeContext = createContext<I_formNodeContext<any>>({} as any)
const FormProvider = <T,>({ value, children }: { children: ReactNode, value: I_formNodeContext<T> }) => {
    return <FormNodeContext.Provider value={value}>{children}</FormNodeContext.Provider>
}
const useFormProvider = () => useContext(FormNodeContext)
export const useForm = <T extends Record<string, any>>(p: I_useFormProps<T>) => {
    const loadingHook = useLoading()
    const dataHook = useData<T>(p)
    const wizardHook = useWizard<T>(p.wizard, dataHook)
    const errorHook = useError<T>(p, wizardHook, loadingHook)
    const inputHook = useInput({ dataHook, errorHook, rootProps: p, wizardHook })
    const renderHook = useRender({ rootProps: p, dataHook, inputHook, errorHook, wizardHook, loadingHook })
    const { errorsDic, errorsList } = errorHook;
    const { data } = dataHook;
    const { disabled } = renderHook;
    const { getChanges } = inputHook;
    return { render: renderHook, errorsDic, errorsList, getChanges, data, disabled }
}
const useLoading = () => {
    const [loading, setLoading] = useState<boolean>(false)
    return { loading, setLoading }
}
const useData = <T,>(rootProps: I_useFormProps<T>) => {
    const initDataStringRef = useRef<string>(JSON.stringify(rootProps.data))
    const dataRef = useRef(rootProps.data); dataRef.current = rootProps.data;
    const isDataChanged = initDataStringRef.current === JSON.stringify(rootProps.data);
    const onChange = (field: string, value: any) => {
        UT.setValueByField(dataRef.current, field, value);
        rootProps.onChange({ ...dataRef.current }, { field, value });
    }
    return { isDataChanged, data: dataRef.current, onChange }
}
const useRender = <T,>(p: {
    rootProps: I_useFormProps<T>,
    dataHook: ReturnType<typeof useData<T>>,
    inputHook: ReturnType<typeof useInput<T>>,
    errorHook: ReturnType<typeof useError<T>>,
    wizardHook: ReturnType<typeof useWizard<T>>,
    loadingHook: ReturnType<typeof useLoading>,
}) => {
    const { inputHook, rootProps, dataHook, errorHook, wizardHook, loadingHook } = p;
    const { wizard, closeText = 'Close', onSubmit, onClose } = rootProps;
    const [disabled, setDisabled] = useState<boolean>(true)
    const getDisabled = (): boolean => loadingHook.loading ? true : !!errorHook.errorsList.length
    const changeDisabled = () => setDisabled(getDisabled())
    useEffect(() => { changeDisabled() }, [dataHook.isDataChanged, errorHook.errorsDic, loadingHook.loading])
    const nodeHook = useNode(!!rootProps.rtl)
    const tagsHook = useTags({ inputHook, rootProps, errorHook, dataHook })
    const mainNodeRef = useRef<I_formNode<T>>(undefined)
    const submit = async () => {
        if (!rootProps.onSubmit) { return }
        loadingHook.setLoading(true)
        const res = await rootProps.onSubmit()
        loadingHook.setLoading(false)
        if (res !== false && rootProps.onClose) { rootProps.onClose() }
    }
    const submitButtonAttrs = (): null | { [key: string]: any } => {
        if (!rootProps.onSubmit) { return null }
        if (rootProps.wizard && !wizardHook.isLastStep(wizardHook.step)) { return null }
        const className = `ai-form-submit-button${disabled ? ' disabled' : ''}`
        return { className, disabled, onClick: submit, type: 'button' }
    }
    const submitButton = () => {
        const attrs = submitButtonAttrs()
        if (attrs === null) { return null }
        let { submitText = 'Submit' } = rootProps;
        const text = typeof submitText === 'function' ? submitText(rootProps.data) : submitText
        const loader = !loadingHook.loading ? null : new UT.GetSvg().getIcon('mdiLoading', 0.8, { spin: 0.4 })
        return (<button {...attrs}>{text}{loader}</button>)
    }
    const wizardStepButtonAttrs = (dir: 1 | -1): null | { [key: string]: any } => {
        const { changeStep, getNextStep, step } = wizardHook
        const { prev = (() => true), next = (() => true) } = step
        const fn = dir === 1 ? next : prev
        const nextStep = getNextStep(dir);
        if (nextStep === false) { return null; }
        const className = `ai-form-wizard-step-button${disabled ? ' disabled' : ''}`
        return {
            type: 'button', className, disabled, onClick: async () => {
                const res = await fn();
                if (res === true) { changeStep(dir) }
            }
        }
    }
    const wizardStepButton = (dir: 1 | -1) => {
        const attrs = wizardStepButtonAttrs(dir);
        const { step } = wizardHook;
        const { nextText = 'Next', prevText = 'Previous' } = step;
        return attrs === null ? null : <button {...attrs}>{dir === 1 ? nextText : prevText}</button>
    }
    const wizardStepButtons = () => !wizard ? null : <>{wizardStepButton(-1)}{wizardStepButton(1)}</>
    const provider = (children: ReactNode) => <FormProvider<T> value={{ inputHook, errorHook, wizardHook, nodeHook, rootProps }}>{children}</FormProvider>
    const closeButtonAttrs = (): null | { [key: string]: any } => !onClose ? null : { type: 'button', className: "ai-form-wizard-close-button", onClick: () => (rootProps as any).onClose() }
    const closeButton = () => { const attrs = closeButtonAttrs(); return attrs === null ? null : <button {...attrs}>{typeof closeText === 'function' ? closeText(rootProps.data) : closeText}</button> }
    const footer = () => {
        if (!wizard && !onSubmit && !onClose) { return null }
        return provider(<div className="ai-form-footer">{closeButton()} {wizardStepButtons()} {submitButton()}</div>)
    }
    const input = (inputName: string, p?: { attrs?: any,nodeName?:string }) => {
        const { attrs = {} } = p || {}
        const input = inputHook.getInputByName(inputName,p?.nodeName || '');
        if (!input) { return null }
        return (provider(<AIInputNode input={input} attrs={attrs} wizardId={''} show={true} inputName={inputName} />))
    }
    const layout = (node: I_formNode<T>) => {
        mainNodeRef.current = node;
        return provider(<AIFormNode node={node} level={0} show={node.show !== false} parentNodes={[]} />)
    }
    const tags = (node: I_formNode<T>, disabled?: boolean) => {
        return provider(<div className='ai-form-tags'>{tagsHook.getTags(node, disabled)}</div>)
    }
    return { input, footer, submitButton, wizardStepButtons, layout, tags, disabled }
}
const useTags = <T,>(p: {
    inputHook: ReturnType<typeof useInput>,
    errorHook: ReturnType<typeof useError<T>>,
    dataHook: ReturnType<typeof useData<T>>,
    rootProps: I_useFormProps<T>
}) => {
    const { rootProps, inputHook, errorHook, dataHook } = p;
    const { fa } = rootProps;
    const tagsResultRef = useRef<ReactNode[]>([])
    const getTag = (param: { value: any, input: I_formInput, inputName: string, indexes: number[], disabled?: boolean }): ReactNode | undefined => {
        const change = (v: any) => inputHook.changeByInput({ input, value: v, wizardId: '', inputName: param.inputName })
        const getOption = (option: any) => {
            let res = { value: undefined, text: undefined }
            if (input.option && input.option.value) { res.value = input.option.value(option, {} as any) || option.value }
            else { res.value = option.value }
            if (input.option && input.option.text) { res.text = input.option.text(option, {} as any) || option.text }
            else { res.text = option.text }
            return res
        }
        let valuePresent: ReactNode = ''
        const { value, input, disabled } = param;
        if (!input.tag) { return }
        let label: ReactNode = input.tag || '';
        if ((value === undefined || value === null || value === '') && input.type !== 'checkbox') { return }
        if (input.type === 'date') {
            const { dateUnit = 'day', jalali } = input
            if (dateUnit === 'month') { valuePresent = new AIODate().getDateByPattern(value, '{year}/{month}', jalali) }
            else if (dateUnit === 'day') { valuePresent = new AIODate().getDateByPattern(value, '{year}/{month}/{day}', jalali) }
        }
        else if (input.type === 'time') {
            const { timeUnit = { year: true, month: true, day: true }, jalali } = input
            valuePresent = new AIODate().getDateByPattern(value, `{year}/{month}/{day}${timeUnit.hour ? ` - {hour} : ${timeUnit.minute ? '{minute}' : '00'}` : ''}`, jalali)
        }
        else if (['radio', 'select', 'buttons', 'toggleButton'].indexOf(input.type) !== -1) {
            const { options = [] } = input;
            if (input.multiple) {
                if (!Array.isArray(value) || !value.length) { return }
                valuePresent = options.filter((o) => {
                    const option = getOption(o);
                    return value.indexOf(option.value) !== -1
                }).map((o) => getOption(o).text).join(' | ')
            }
            else {
                const res = options.find((o) => value === getOption(o).value)
                valuePresent = getOption(res).text
            }
        }
        else if (input.type === 'checkbox') {
            valuePresent = input.text || input.label
            label = (<div className="ai-tag-checkbox" onClick={() => change(!value)}><CheckIcon checked={!!value} /></div>)
        }
        else if (typeof value === 'number') { valuePresent = UT.SplitNumber(value) }
        else { valuePresent = value }
        const text = (<div className={UT.classListToString(['ai-form-tag', disabled ? 'ai-form-tag-disabled' : undefined])} key={input.field + param.indexes.join('-')}>
            <div className='ai-form-tag-label'>{label}</div>
            <div className='ai-form-tag-value'>{valuePresent}</div>
            {!disabled && <div className="ai-form-tag-remove" onClick={(e) => { e.stopPropagation(); inputHook.changeByInput({ input, value: undefined, wizardId: '', inputName: param.inputName }) }}>{new UT.GetSvg('em').getIcon('mdiClose', 0.6)}</div>}
        </div>)
        if (!disabled) {
            let props: any = { caret: false, text, value, rtl: !!fa, className: 'ai-form-tag-input', onChange: change, before: undefined, after: undefined, subtext: undefined, hideTags: true }
            if (input.type === 'checkbox') {
                return text
            }
            if (['radio', 'select', 'buttons', 'toggleButton'].indexOf(input.type) !== -1) {
                props = { ...input, type: 'select', option: { ...input.option, justify: () => false }, popover: { modalAttrs: { style: { minWidth: '8em' } } }, ...props }
            }
            else if (input.type === 'date' || input.type === 'time') { props = { ...input, ...props } }
            else {
                props = {
                    type: 'button', ...props,
                    popover: {
                        body: <AIOInput {...input} value={value} onChange={change} />,
                        bodyAttrs: { style: { padding: 0, borderRadius: '0.4em', border: 'none' } }
                    },

                }
            }
            return (<AIOInput {...props} />)
        }
        return text
    }
    const getTags = (node: I_formNode<T>, disabled?: boolean) => {
        tagsResultRef.current = []
        getTags_req(node, [], disabled)
        return tagsResultRef.current
    }
    const getTags_req = (node: I_formNode<T>, indexes: number[], disabled?: boolean) => {
        if (node.input) {
            const input = inputHook.getInputByName(node.input,node.name || '')
            if (!input) { return }
            if (!input.tag) { return }
            const value = inputHook.getValueByInput(input, node.input);
            const error = errorHook.getErrorByInput(input, node.input, value, dataHook.data)
            if (!error) {
                const res = getTag({ value, input, indexes, disabled, inputName: node.input })
                if (res) { tagsResultRef.current.push(res) }
            }
        }
        else {
            const nodes = node.v || node.h || []
            for (let i = 0; i < nodes.length; i++) { getTags_req(nodes[i], [...indexes, i], disabled) }
        }
    }
    return { getTags }
}
const useInput = <T,>(p: { dataHook: ReturnType<typeof useData<T>>, rootProps: I_useFormProps<T>, errorHook: ReturnType<typeof useError<T>>, wizardHook: ReturnType<typeof useWizard<T>> }) => {
    const { rootProps, errorHook, dataHook, wizardHook } = p;
    const { option } = rootProps;
    const initValuesRef = useRef<{ [inputName: string]: { value: any } }>({})
    const fieldChangesRef = useRef<any>({})
    const getValueByField = (field: string) => UT.getValueByField(dataHook.data, field)
    const getValueByInput = (input: I_formInput, inputName: string) => {
        const value = getValueByField(input.field)
        if (!initValuesRef.current[inputName]) { initValuesRef.current[inputName] = { value } }
        return value
    }
    const getChanges = () => Object.keys(fieldChangesRef.current).map((field) => fieldChangesRef.current[field])
    const getInputByName = (inputName: string,nodeName:string): I_formInput | false => {
        const input = rootProps.inputs[inputName]
        if (!input) { return false }
        let res: I_formInput = { ...input };
        if(!option){return res}
        for (let prop in option) {
            if (prop === 'validate') { continue }
            const fn:any = (option as any)[prop]
            const v = (res as any)[prop];
            (res as any)[prop] = v === undefined ? fn({ inputName, data: dataHook.data, input: res,nodeName }) : v
        }
        return res
    }
    const changeByInput = (p: { input: I_formInput, value: any, wizardId: string, inputName: string }) => {
        fieldChangesRef.current = {
            ...fieldChangesRef.current,
            [p.inputName]: { from: initValuesRef.current[p.inputName], to: p.value, input: p.input }
        }
        errorHook.updateErrorByInputValue(p)
        dataHook.onChange(p.input.field, p.value);
    }
    const getInputProps = (p: { input: I_formInput, inputName: string, value: any, wizardId: string, error?: string }) => {
        const obj = p.input;
        const { inputAttrs, field } = obj
        const wrappedAttrs = UT.AddToAttrs(p.input.attrs, { className: [p.input.className, !!p.error ? 'has-error' : undefined] })
        const inputProps = {
            ...p.input, ...wrappedAttrs, inputAttrs: { ...inputAttrs, 'aria-label': field }, value: p.value, rtl: !!p.input.rtl || !!rootProps.fa,
            onChange: async (v: any) => changeByInput({ input: p.input, value: v, wizardId: p.wizardId, inputName: p.inputName })
        }
        if (wizardHook.isDisabledByStep(p.wizardId)) { inputProps.disabled = true }
        return inputProps;
    }
    const renderInput = (inputProps: I_formInput) => {
        if (inputProps.type === "custom") {
            if (!inputProps.customType) {
                console.error('useForm error => input.type is set as "custom" but missing set input.customType');
                return null
            }
            if (!rootProps.customTypes || !rootProps.customTypes[inputProps.customType]) {
                console.error(`useForm error => input.customType is set as "${inputProps.customType}" but missing set customTypes.${inputProps.customType} in hook root props`);
                return null
            }
            else {
                return rootProps.customTypes[inputProps.customType]({ ...inputProps as any })
            }
        }
        else { return <AIOInput {...inputProps} /> }
    }
    return { getValueByInput, changeByInput, getInputByName, getChanges, getInputProps, renderInput }
}
const useWizard = <T,>(wizard: I_useFormProps<any>["wizard"], dataHook: ReturnType<typeof useData<T>>) => {
    const steps = (wizard?.steps || [])
    const [step, setStep] = useState<I_wizardStep<T>>(getFirstStep);
    const stepRef = useRef<I_wizardStep<T>>(step);
    stepRef.current = step;
    function getFirstStep(): I_wizardStep<T> { return steps.find(({ show = () => true }) => !!show(dataHook.data)) as I_wizardStep<T> }
    const getLastStep = (): I_wizardStep<T> => {
        const list = [...steps]
        list.reverse()
        return list.find(({ show = () => true }) => !!show(dataHook.data)) as I_wizardStep<T>
    }
    const isLastStep = (step: I_wizardStep<T>) => {
        const lastStep = getLastStep();
        return step.id === lastStep.id
    }
    const isFirstStep = (step: I_wizardStep<T>) => step.id === getFirstStep().id
    const getNextStep = (dir: 1 | -1, step?: I_wizardStep<T>): I_wizardStep<T> | false => {
        step = step || stepRef.current;
        const index = steps.findIndex((o) => o.id === step.id);
        if (index === -1) { return false }
        let newIndex = index + dir;
        if (newIndex < 0) { return false }
        if (newIndex > steps.length - 1) { return false }
        const newStep = steps[newIndex];
        const show = (newStep.show || (() => true))(dataHook.data);
        if (show) { return newStep }
        return getNextStep(dir, newStep)
    }
    const changeStep = (dir: 1 | -1) => {
        const step = stepRef.current;
        const newStep = getNextStep(dir, step)
        if (newStep === false) { return }
        setStep(newStep)
    }
    const getShow = (wizardId?: string) => (!wizardId || !wizard || !step) ? true : step.id === wizardId
    const getWizardId = (node: I_formNode<T>, parentNodes: I_formNode<T>[]): string => {
        const parentResult = parentNodes.find((o) => !!o.wizardId);
        if (parentResult) { return parentResult.wizardId || '' }
        return node.wizardId || ''
    }
    const isDisabledByStep = (wizardId: string) => {
        const step = steps.find((o) => o.id === wizardId)
        if (!step) { return false }
        return !!step.disabled;
    }
    return { step, setStep, getFirstStep, getLastStep, isLastStep, isFirstStep, changeStep, getNextStep, getShow, getWizardId, isDisabledByStep }
}
type I_formError = { text: string, wizardId: string }
type I_formErrorsDic = { [inputName: string]: I_formError | undefined }
type I_fetchErrorDic = { [field: string]: { error: string | undefined, value: any } }
const useError = <T,>(rootProps: I_useFormProps<T>, wizardHook: ReturnType<typeof useWizard<T>>, loadingHook: ReturnType<typeof useLoading>) => {
    const [errorsDic, setErrorsDic] = useState<I_formErrorsDic>({})
    const [fetchErrorDic, setFetchErrorDic] = useState<I_fetchErrorDic>({})
    const errorsRef = useRef<I_formErrorsDic>(errorsDic)
    errorsRef.current = errorsDic
    const handleFetchError = async (inputName: string, value: any) => {
        if (fetchErrorDic[inputName]?.value === value) { return }
        const { fetchError = {} } = rootProps;
        if (typeof fetchError[inputName] !== 'function') { return }
        loadingHook.setLoading(true)
        const error = await fetchError[inputName](value)
        loadingHook.setLoading(false)
        const newFetchErrorDic: I_fetchErrorDic = { ...fetchErrorDic, [inputName]: { error: error || undefined, value } }
        setFetchErrorDic(newFetchErrorDic);
    }
    function getErrorByInput(input: I_formInput, inputName: string, value: any, data: T): string | void {
        const { validations = {}, fa, fetchError = {} } = rootProps;
        const { label = '', required = false } = input;
        const inputValidations = Array.isArray(input.validation) ? [...input.validation] : (input.validation ? [input.validation] : [])
        const requiredError = UT.getErrorByRequired({ label, fa, value, required });
        if (requiredError) { return requiredError }
        const isNull = value === undefined || value === '' || value === null
        if (isNull) { return }
        const validationTypeError = new UT.Validation({ fa }).validate({ label, validation: inputValidations, value });
        if (validationTypeError) { return validationTypeError }
        for (let i = 0; i < inputValidations.length; i++) {
            const inputValidation = inputValidations[i];
            const validation = validations[inputValidation];
            if (!validation) { continue }
            const res = validation({ inputName, value, data });
            if (res) { return res }
        }
        if (fetchError[inputName]) {
            handleFetchError(inputName, value)
            if (fetchErrorDic[inputName]?.error) { return fetchErrorDic[inputName]?.error }
        }
    }
    const setErrorByInputName = (p: { inputName: string, error?: string, wizardId: string }) => {
        if (errorsRef.current[p.inputName]?.text === p.error) { return }
        const newError: I_formError | undefined = p.error !== undefined ? { text: p.error, wizardId: p.wizardId } : undefined
        const newErrors: I_formErrorsDic = { ...errorsRef.current, [p.inputName]: newError }
        errorsRef.current = newErrors;
        setErrorsDic(newErrors)
    }
    const updateErrorByInputValue = async (p: { input: I_formInput, inputName: string, value: any, wizardId: string, show?: boolean }) => {
        const errorsDic = errorsRef.current;
        const error = p.show === false ? undefined : getErrorByInput(p.input, p.inputName, p.value, rootProps.data) || undefined;
        if (errorsDic[p.inputName]?.text === error) { return }
        setErrorByInputName({ inputName: p.inputName, error, wizardId: p.wizardId });
    }
    const getErrorsList = (): string[] => {
        const errorsDic = errorsRef.current as any;
        const res = []
        for (let inputName in errorsDic) {
            if (rootProps.wizard && !!errorsDic[inputName] && errorsDic[inputName].wizardId !== wizardHook.step.id) { continue }
            if (!!errorsDic[inputName]) { res.push(errorsDic[inputName].text) }
        }
        return res
    }
    const errorsList = getErrorsList()
    return { errorsDic, errorsList, updateErrorByInputValue, getErrorByInput }
}
const useNode = (rtl: boolean) => {
    const getStyle = (node: I_formNode<any>) => {
        const res: any = { flex: node.flex };
        return { ...res, ...node.style }
    }
    function getVisibilityClassNames(node: I_formNode<any>): string[] {
        let hide_xs, hide_sm, hide_md, hide_lg, classNames = [];
        if (node.show_xs) { hide_xs = false; hide_sm = true; hide_md = true; hide_lg = true; }
        if (node.hide_xs) { hide_xs = true; }
        if (node.show_sm) { hide_xs = true; hide_sm = false; hide_md = true; hide_lg = true; }
        if (node.hide_sm) { hide_sm = true; }
        if (node.show_md) { hide_xs = true; hide_sm = true; hide_md = false; hide_lg = true; }
        if (node.hide_md) { hide_md = true; }
        if (node.show_lg) { hide_xs = true; hide_sm = true; hide_md = true; hide_lg = false; }
        if (node.hide_lg) { hide_lg = true; }
        if (hide_xs) { classNames.push('ai-form-hide-xs') }
        if (hide_sm) { classNames.push('ai-form-hide-sm') }
        if (hide_md) { classNames.push('ai-form-hide-md') }
        if (hide_lg) { classNames.push('ai-form-hide-lg') }
        return classNames;
    }
    const getClassNames = (node: I_formNode<any>, level: number): (string | undefined)[] => {
        const alignCls = {
            v: 'ai-form-items-center', h: 'ai-form-justify-center',
            vh: 'ai-form-items-center ai-form-justify-center',
            hv: 'ai-form-items-center ai-form-justify-center',
        }
        if (node.v) { alignCls.v = 'ai-form-justify-center'; alignCls.h = 'ai-form-items-center'; }
        const key = node.html ? 'html' : (node.input ? 'input' : (node.v ? 'v' : 'h'))
        return [
            node.className, level === 0 ? `ai-form-${rtl ? 'rtl' : 'ltr'}` : undefined,
            level === 0 ? 'ai-form' : undefined, `ai-form-${key}`, node.scroll ? `ai-form-scroll-${key}` : undefined,
            node.align ? alignCls[node.align] : undefined, `ai-form-level-${level}`,
            ...getVisibilityClassNames(node)
        ]
    }
    const getAttrs = (p: { node: I_formNode<any>, level: number }) => {
        const { node, level } = p;
        const res = UT.AddToAttrs(node.attrs, { className: getClassNames(node, level), style: getStyle(node) })
        const result = { ...res, style: { ...res.style } }
        return result
    }
    return { getAttrs }
}
interface AIFormNodeProps {
    node: I_formNode<any>;
    parentNodes: I_formNode<any>[];
    level: number;
    show: boolean;
}
const RenderByTagName: FC<{ content: ReactNode, tagName: I_formTag, attrs?: any }> = ({ content, tagName, attrs }) => {
    if (tagName === 'section') { return (<section {...attrs}>{content}</section>) }
    if (tagName === 'fieldset') { return (<fieldset {...attrs}>{content}</fieldset>) }
    if (tagName === 'p') { return (<p {...attrs}>{content}</p>) }
    if (tagName === 'form') { return (<form {...attrs}>{content}</form>) }
    return (<div {...attrs}>{content}</div>)
}
const AIFormNode: FC<AIFormNodeProps> = ({ node, level, parentNodes, show }) => {
    const { wizardHook, nodeHook, inputHook } = useFormProvider();
    const wizardId = wizardHook.getWizardId(node, parentNodes);
    const { footer, header, panel, deps } = node;

    const wizardShow = wizardHook.getShow(node.wizardId);
    const Show = node.show !== false && show !== false && !!wizardShow;

    const getContent = (): ReactNode => {
        let content: ReactNode = null;
        if (Array.isArray(node.h) || Array.isArray(node.v)) {
            let { tag = level === 0 ? 'form' : 'div', legend } = node;
            const inside = (<>
                {!!legend && tag === 'fieldset' && <legend>{legend}</legend>}
                {
                    (node as any)[node.v ? 'v' : 'h'].map((o: I_formNode<any>, i: number) => {
                        return (<AIFormNode node={o} parentNodes={[...parentNodes, node]} key={`level-${level + 1}-index-${i}`} level={level + 1} show={Show} />)
                    })
                }
            </>)
            const attrs = nodeHook.getAttrs({ node, level })
            if (!Show) { attrs.style = { ...attrs.style, display: 'none' } }
            content = <RenderByTagName attrs={attrs} content={inside} tagName={tag} />
        }
        else if (node.html !== undefined) {
            if (!Show) return null;
            const attrs = nodeHook.getAttrs({ node, level });
            content = <div {...attrs}>{node.html}</div>;
        }
        else if (node.input) {
            const input = inputHook.getInputByName(node.input,node.name || '');
            if (!input) return null;
            const attrs = { ...nodeHook.getAttrs({ node, level }), 'data-label': input.label };
            const p = { attrs, input, wizardId, show: Show, inputName: node.input, debugId: node.debugId }
            content = (<AIInputNode key={node.input} {...p} />);
        }
        if (footer !== undefined || header !== undefined) { content = <div className="ai-form-fdc">{header}{content}{footer}</div>; }
        if (panel) {
            const attrs = UT.AddToAttrs(node.panelAttrs, { className: "ai-form-panel" });
            content = (<div {...attrs}><div className="ai-form-panel-label">{panel}</div>{content}</div>);
        }
        return content;
    };
    const customMemo = UT.useCustomMemo()
    return customMemo.render(deps, getContent)
};
export const AIInputNode: FC<{ input: I_formInput; attrs?: any; wizardId: string; show: boolean; inputName: string; debugId?: string; }> = (props) => {
    const { input, attrs, wizardId, show, inputName } = props
    const { inputHook, rootProps, errorHook } = useFormProvider();
    const { showErrors } = rootProps;
    const { label, required, labelType, labelAttrs } = input;
    const value = inputHook.getValueByInput(input, props.inputName);
    if (!show) { errorHook.updateErrorByInputValue({ input, inputName, value, wizardId, show: false }); }
    else { errorHook.updateErrorByInputValue({ input, inputName, value, wizardId }); }
    const error = errorHook.errorsDic[inputName]?.text;
    const customMemo = UT.useCustomMemo()
    const inputProps = inputHook.getInputProps({ input, inputName, value, wizardId, error });
    if (!show || inputProps === null) return null;
    const finalInput = inputHook.renderInput(inputProps);
    const propsForCache = { required, labelAttrs, labelType, label, error, showErrors, attrs, value, show, debugId: props.debugId, input };
    const getContent = () => <AIFormInput {...propsForCache} input={finalInput} />
    return customMemo.render(propsForCache, getContent)
}
export const AIFormInput: FC<{
    label?: string, labelType?: 'inline' | 'online', labelAttrs?: any, showErrors?: boolean,
    attrs?: any, id?: string, className?: string, style?: any,
    before?: ReactNode, after?: ReactNode, footer?: ReactNode, subtext?: string,
    error?: string, validation?: string[], required?: boolean,
    input: ReactNode,
    value?: any,
    fa?: boolean, debugId?: string
}> = (props) => {
    const { label = '', input, attrs, id, required = false, labelAttrs, className, style, labelType, value, validation, fa, showErrors = true } = props;
    const Attrs = UT.AddToAttrs(attrs, { className: ["ai-form-input", className], style })

    function getError(): string | undefined {
        if (props.error) { return props.error }
        else if (validation) {
            const inputValidations = Array.isArray(validation) ? [...validation] : (!!validation ? [validation] : [])
            const requiredError = UT.getErrorByRequired({ label, fa, value, required });
            if (requiredError) { return requiredError }
            const validationTypeError = new UT.Validation({ fa }).validate({ label, validation: inputValidations, value });
            if (validationTypeError) { return validationTypeError }
        }
    }
    const errorResult = getError()
    const LabelAttrs = UT.AddToAttrs(labelAttrs, { className: ['ai-form-input-label', !!errorResult ? 'has-error' : undefined], attrs: { htmlFor: id, title: errorResult } })
    const renderBody = (
        <div className="ai-form-input-body">
            {!!props.before && <div className="ai-form-input-body-before"></div>}
            <div className="ai-form-input-body-input" data-subtext={!!props.subtext ? props.subtext : undefined}>{input}</div>
            {!!props.after && <div className="ai-form-input-body-after"></div>}
        </div>
    )
    const renderError = !!errorResult && !!showErrors ? <div className="ai-form-input-error">{errorResult}</div> : null
    const content = <>{renderBody} {renderError}</>
    return (<LabelLayout attrs={Attrs} content={content} required={required} label={label} labelType={labelType} labelAttrs={LabelAttrs} />)
}
const LabelLayout: FC<{ attrs: any, content: ReactNode, label?: ReactNode, labelAttrs: any, labelType?: 'inline' | 'online', required?: boolean }> = ({ attrs, content, label, labelAttrs, labelType, required }) => {
    const getLabel = () => {
        if (!label) { return null }
        const content = <label {...labelAttrs}>{required ? <div className="ai-form-required">*</div> : null}{label}</label>;
        return labelType === 'online' ? <div className="ai-form-input-online-label">{content}</div> : <>{content}</>
    }
    const renderLabel = getLabel()
    const layout = (<div {...attrs}>{labelType !== 'inline' ? renderLabel : null} {content}</div>)
    return labelType === 'inline' ? <div className="ai-form-inline-label">{renderLabel} {layout}</div> : <>{layout}</>
}
// #endregion
// #region mask
const AIMaskComponent = () => {
    const { rootProps,mainRef } = useProvider()
    const props = { ...rootProps, maskPattern: rootProps.maskPattern || [] }
    const [values, setValues] = useState<string[]>(props.maskPattern.map((_,i)=>props.value[i] || ''))
    const valuesRef = useRef(values)
    valuesRef.current = values
    useEffect(() => {
        setValues(props.maskPattern.map((_,i)=>props.value[i] || ''))
    }, [props.value.join('')])
    function SetValue(values: any, value: string, patternIndex: number) {
        if (!props.onChange) { return }
        const pattern = props.maskPattern[patternIndex];
        const patternLength = pattern.length;
        setValues(values)
        props.onChange(values)
        if ((patternLength !== undefined && value.length === patternLength) || pattern.type === "select") {
            const inputs = $(mainRef.current as any).find('.aio-input-mask-item');
            let newIndex = patternIndex + 1
            if (newIndex + 1 > inputs.length) { return }
            let input = inputs.eq(newIndex).find('input');
            if (input.length) { input.focus().select(); }
        }
    }
    function changeValue(value: any, patternIndex: number) {
        if (props.maskPattern[patternIndex].disabled) { return }
        let newValues = valuesRef.current.map((o, j) => patternIndex === j ? value : o);
        SetValue(newValues, value, patternIndex)
    }
    function getOptions(options: any) {
        if (options === 'fa-plate') { return ['الف', 'ب', 'ت', 'ج', 'ح', 'د', 'ر', 'ز', 'ژ', 'س', 'ص', 'ط', 'ع', 'ف', 'ق', 'ک', 'گ', 'ل', 'م', 'ن', 'و', 'ه'] }
        return options || []
    }
    function getList() {
        return props.maskPattern.map((o, patternIndex) => {
            const p: I_AIOInput = {
                type: o.type, justify: true, delay: 0, placeholder: o.placeholder, maxLength: o.length, filter: o.type === 'number' ? ['number'] : undefined,
                attrs: UT.AddToAttrs(
                    o.attrs, { 
                        className: ['aio-input-mask-item', o.className, o.disabled ? 'aio-input-mask-item-disabled' : undefined], 
                        style: {flex:o.flex || o.length || 1,...o.attrs?.style,...o.style} 
                    }
                ),
                value: valuesRef.current[patternIndex], onChange: o.disabled ? undefined : (v: string) => changeValue(v, patternIndex), autoHighlight: o.disabled ? false : undefined
            }
            const after = o.after !== undefined ? <div className='aio-input-mask-gap'>{o.after}</div> : null
            if (o.type === 'text' || o.type === 'number') { return (<><AIText {...p} /> {after}</>) }
            else if (o.type === 'select') { return (<><AISelect {...p} options={getOptions(o.options)} option={{ text: (o) => o, value: (o) => o }} />{after}</>) }
        })
    }
    return (
        <>
            {getList()}
        </>
    )
}
// #endregion
// #region panels
type I_PanelsContext = {
    isOpen: (id: any) => boolean,
    rootProps: I_AIOInput
}
const PanelsContext = createContext({} as any);
export const Panels: FC = () => {
    const { rootProps, optionDetails } = useProvider();
    const { multiple, vertical = true, value } = rootProps;
    function isOpen(id: any) {
        if (!multiple) { return id === value }
        else { return (value || []).indexOf(id) !== -1 }
    }
    function getContext() {
        let context: I_PanelsContext = {
            rootProps, isOpen
        }
        return context;
    }
    return (
        <PanelsContext.Provider value={getContext()}>
            <div className={`aio-input-panels aio-input-scroll${vertical ? ' aio-input-panels-vertical' : ' aio-input-panels-horizontal'}`}>
                {optionDetails.list.map((optionDetail, i: number) => <PanelsItem key={i} optionDetail={optionDetail} />)}
            </div>
        </PanelsContext.Provider>
    )
}
type I_PanelsItem = { optionDetail: AI_optionDetail }
const PanelsItem: FC<I_PanelsItem> = ({ optionDetail }) => {
    const active = !!optionDetail.active
    let Attrs = UT.AddToAttrs(optionDetail.attrs, { className: `aio-input-panels-item` })
    return (
        <div {...Attrs}>
            <AILayout optionDetail={optionDetail} />
            {!!active && <PanelsBody optionDetail={optionDetail} />}
        </div>
    )
}
type I_PanelsBody = { optionDetail: AI_optionDetail }
const PanelsBody: FC<I_PanelsBody> = ({ optionDetail }) => {
    let { body } = optionDetail;
    if (!body || body === null) { return null }
    let Attrs = UT.AddToAttrs({}, { className: [`aio-input-panels-body`, 'ai-border-radius-md'] })
    return <div {...Attrs}>{body}</div>
}
// #endregion
// #region joystick
type I_joystick = {
    angleDir?: 'clock' | 'clockwise'
    scale?: number, size: number, buttonSize: number,
    angleStep?: number,
    step?: number,
    arrow?: { count: number, color: string },
    onChange: (v: { percent: number, angle: number, x: number, y: number }) => void,
    onEnd?: () => void,
    centerOriented?: boolean,
    value: { x?: number, y?: number, percent?: number, angle?: number }
}
export const JoyStick: FC<I_joystick> = (props) => {
    const geo = new UT.Geo()
    const { scale = 1, buttonSize, size } = props
    function change(data: { percent: number, angle: number }) {
        let { percent, angle } = data;
        percent /= scale;
        if (angle < 0) { angle = 360 + angle }
        props.onChange(convert({ percent, angle }))
    }
    const convert = (v: { x?: number, y?: number, percent?: number, angle?: number }): { x: number, y: number, percent: number, angle: number } => {
        const limit = size / 2 - buttonSize / 2
        if (v.angle !== undefined && v.percent !== undefined) {
            const angle = props.angleDir === 'clockwise' ? -v.angle : v.angle
            const length = limit * v.percent / 100
            const [x, y] = geo.getLineBySLA([0, 0], length, angle)[1];
            return { percent: v.percent, angle: v.angle, x: +x.toFixed(0), y: +y.toFixed(0) }
        }
        else if (v.x !== undefined && v.y !== undefined) {
            const line: any = [[0, 0], [v.x, v.y]]
            let angle = geo.getAngle(line)
            angle = props.angleDir === 'clockwise' ? -angle : angle
            const length = geo.getLength(line)
            let percent = 100 * length / limit;
            if (percent > 100) { percent = 100 }
            const x = v.x
            const y = v.y
            return { x, y, percent, angle }
        }
        return { x: 0, y: 0, percent: 0, angle: 0 }
    }
    const { x, y } = convert(props.value)
    return <JOYSTICK props={props} x={x * scale} y={y * scale} onChange={change} />
}
const JOYSTICK: FC<{
    props: I_joystick, x: number, y: number,
    onChange: (v: { percent: number, angle: number }) => void,
}> = ({ x: X, y: Y, onChange, props: ppp }) => {
    const geo = new UT.Geo()
    const { step = 1, angleStep = 1, arrow, buttonSize, size, onEnd, angleDir, centerOriented } = ppp
    const limit = size / 2 - buttonSize / 2
    const [dom] = useState<any>(createRef())
    useEffect(() => { new UT.Swip({ dom: () => $(dom.current), start: () => [0, 0], move, end, maxCenterDistance: size / 2 }) }, [])
    function end() {
        if (onEnd) { onEnd(); }
        if (centerOriented) { onChange({ angle: 0, percent: 0 }) }
    }
    function move(p: UT.I_Swip_parameter) {
        let { centerAngle, centerDistance }: UT.I_Swip_mousePosition = p.mousePosition;
        if (centerDistance > limit) { centerDistance = limit }
        centerAngle = UT.getValueByStep({ value: centerAngle, step: angleStep, start: 0, end: 360 })
        let percent = 100 * centerDistance / limit
        percent = UT.getValueByStep({ value: percent, step, start: 0, end: 100 })
        const angle = centerAngle * (angleDir === 'clockwise' ? -1 : 1)
        onChange({ percent, angle })
    }
    const line: any = [[0, 0], [X, Y]]
    const length = geo.getLength(line)
    const a = geo.setLineByLength(line, Math.min(length, limit))
    const x = a[1][0]
    const y = a[1][1]
    const left = x + size / 2
    const top = y + size / 2
    return (
        <div style={{ width: size, height: size }} className='joy-stick' ref={dom as any} draggable={false}>
            {
                !!arrow ?
                    UT.GetArray(arrow.count).map((o) => {
                        return <div className="j-arrow" style={{ transform: `rotate(${o * (360 / arrow.count)}deg)` }} draggable={false}>
                            <div style={{ left: size / 2, position: 'absolute', display: 'flex', alignItems: 'center', color: arrow.color }} draggable={false}>
                                {new GetSvg().getIcon('mdiChevronRight', size / 120)}
                            </div>
                        </div>
                    }) : null
            }
            <div style={{ left, top }} className='joy-stick-button' draggable={false}>
                <div style={{ width: buttonSize, height: buttonSize }} draggable={false}></div>
            </div>
        </div>
    )
}
// #endregion
// #region scanner
type I_ScannerButton = {
    fa?: boolean, reset?: boolean, close?: boolean, fps?: number, onScan: (v: any) => Promise<boolean | string>,
    value?: any, attrs?: any, text?: ReactNode
}
export const ScannerButton: FC<I_ScannerButton> = (props) => {
    const { fa, close = true, fps = 20, onScan = () => { }, value, text = new UT.GetSvg('em').getIcon('mdiCamera', .8), attrs } = props;
    const idRef = useRef<string>('b' + UT.GetRandomNumber(1000000, 9999999))
    const valueRef = useRef<string[]>(value)
    valueRef.current = value;
    const popup = usePopup();

    const getCount = () => {
        const value = valueRef.current;
        if (Array.isArray(value)) { return value.length }
    }
    const updateScannedLabel = () => {
        try { $(`#${idRef.current}`).find('.scan-result').html(getScannedLabel()) } catch { }
    }
    useEffect(() => { updateScannedLabel() }, [value])
    const getScannedLabel = () => {
        const count = getCount();
        if (typeof count !== 'number') { return '' }
        return `${count} ${fa ? 'مورد اسکن شده' : 'item scanned'}`
    }
    const handleScan = async (scannedValue: string): Promise<true | string> => {
        const res: true | string = await onScan(scannedValue) || (fa ? 'خطایی رخ داد' : 'scan was unsuccessful')
        if (res === true) {
            PlaySound(true)
            if (close) { popup.removeModal() }
        }
        else { PlaySound(false) }
        return res
    };

    const handleScanCamera = () => {
        popup.addModal({
            header: { html: () => null }, position: 'center',
            modalAttrs: { id: idRef.current },
            body: (
                <div className="flex flex-col" style={{ direction: fa ? 'rtl' : 'ltr' }}>
                    <div className="scan-result">{getScannedLabel()}</div>
                    <Scanner onScan={async (v: string) => await handleScan(v)} onClose={() => popup.removeModal()} fps={fps} />
                </div>
            )
        });
    };
    const Attrs = UT.AddToAttrs(attrs, { className: "ai-scanner-button", style: { direction: fa ? 'rtl' : 'ltr' }, attrs: { onClick: () => handleScanCamera() } })
    return (<><button {...Attrs}>{text}</button>{popup.render()}</>);
};
// #endregion
// #region tree
type I_TreeContext = {
    rootProps: AI_Tree,
    tree: ReturnType<typeof useTree>,
}
const TreeContext = createContext<I_TreeContext>({} as any)
const TreeProvider: FC<{ value: I_TreeContext, children: ReactNode }> = ({ value, children }) => {
    return <TreeContext.Provider value={value}>{children}</TreeContext.Provider>
}
const useTreeProvider = () => useContext(TreeContext)
type I_treeRowDetails = { level: number, index: number, isLastChild: boolean, isFirstChild: boolean, parentDetails?: I_treeRowDetails, value: any, row: any, option: AI_optionDetail }
export type AI_Tree = {
    value: any[],
    indent?: number,
    onToggle?: (openDic: { [id: string]: boolean }) => void,
    setChilds?: (rowDetails: I_treeRowDetails, childs: undefined | any[]) => void,
    onChange?: (v: any) => void,
    option?: AI_optionProp,
    attrs?: any,
    className?: string,
    autoHeight?: boolean,
    rtl?: boolean,
    style?: any,
}
const AITreeComponent: FC<AI_Tree> = (props) => {
    const tree = useTree(props)
    let Attrs = UT.AddToAttrs(props.attrs, { className: ['aio-input-tree', props.className, props.rtl ? 'aio-input-tree-rtl' : undefined], style: props.style })
    tree.resetParentValuesDic()
    return (
        <TreeProvider value={{ rootProps: props, tree }}>
            <div {...Attrs}><TreeBody rows={props.value} level={0} parents={[]} /></div>
        </TreeProvider>
    )
}
const TreeBody: FC<{ rows: any[], level: number, parentDetails?: I_treeRowDetails, parents: AI_optionDetail[] }> = (props) => {
    let { rootProps, tree } = useTreeProvider();
    let { rows, level, parentDetails } = props;
    let { option = {} } = rootProps;
    let { list } = tree.optionsHook.getOptions({
        rootProps: { ...rootProps, type: 'tree' },
        optionOrgs: rows, optionProp: option, level,
        parentOptions: props.parents,
        isOpen: (value: any) => tree.isOpen(value), change: (row: any, newRow: any) => tree.change(row, newRow),
        toggle: ({ row, index, level, value, state }) => {
            const childs = tree.getChilds(row, index, level)
            if (childs) { tree.toggle(value, state) }
        },
        getChilds: tree.getChilds
    })
    function getClassName() {
        let className = 'aio-input-tree-body';
        if (!props.parentDetails) { className += ' aio-input-tree-root' }
        const parentValue = props.parentDetails?.value;
        if (tree.isOpen(parentValue)) { className += ' open' }
        className += tree.getMountClassName(parentValue);
        className += ` aio-input-tree-body-level-${level}`
        return className
    }
    return (
        <div className={getClassName()}>
            {list.map((option: AI_optionDetail, index: number) => {
                const { optionOrg: row } = option;
                const value = option.value;
                const isFirstChild = option.isFirstChild;
                const isLastChild = option.isLastChild;
                tree.setParentvalueDic(value, props.parents.map((o) => o.value))
                let details: I_treeRowDetails = { level, value, index, isLastChild, isFirstChild, parentDetails: props.parentDetails, row, option }
                const childs = tree.getChilds(details.row, details.index, details.level);
                let open: boolean | undefined = !childs ? undefined : (!!tree.isOpen(details.value) ? true : false);
                return (
                    <Fragment key={value}>
                        <TreeRow details={details} parentDetails={parentDetails} />
                        {
                            Array.isArray(childs) && open !== false &&
                            <TreeBody
                                parents={[...props.parents, option]}
                                rows={childs}
                                level={details.level + 1}
                                parentDetails={details}
                            />
                        }
                    </Fragment>
                );
            })}
        </div>
    )
}
const TreeRow: FC<{ details: I_treeRowDetails, parentDetails?: I_treeRowDetails }> = (props) => {
    let { tree, rootProps } = useTreeProvider();
    let { details } = props;
    let childs = tree.getChilds(details.row, details.index, details.level);
    let open: boolean | undefined = !childs ? undefined : (!!tree.isOpen(details.value) ? true : false);
    const { row, option, level } = details;
    return (
        <AILayout
            {...option} optionDetail={option}
            indent={option.toggleIcon !== false && (
                <UT.Indent
                    row={row} width={rootProps.indent || 24} level={level} isLastChild={details.isLastChild} isLeaf={!childs}
                    isParentLastChild={!!props.parentDetails?.isLastChild} rtl={!!rootProps.rtl}
                    toggleIcon={option.toggleIcon} open={open} onToggle={() => tree.toggle(details.value)}
                />
            )}
        />
    )
}

const useTree = (props: AI_Tree) => {
    const optionsHook = useOptions();
    let [openDic, setOpenDic] = useState<any>({}), openDicRef = useRef(openDic); openDicRef.current = openDic
    let [mountedDic, setMountedDic] = useState<{ [id: string]: boolean }>({}), mountedDicRef = useRef(mountedDic); mountedDicRef.current = mountedDic
    const parentValuesDicRef = useRef<{ [value: string]: string[] }>({})
    const resetParentValuesDic = () => parentValuesDicRef.current = {}
    const setParentvalueDic = (value: string, parentValues: any[]) => {
        parentValuesDicRef.current = { ...parentValuesDicRef.current, [value]: parentValues }
    }
    function SetMounted(id: string, state: boolean) { setMountedDic({ ...mountedDicRef.current, [id]: state }) }
    function SetOpen(id: string, state: boolean) {
        const newOpenDic = { ...openDicRef.current, [id]: state }
        setOpenDic(newOpenDic)
    }
    function toggle(id: any, state?: boolean) {
        let open = state === undefined ? isOpen(id) : state, time = props.autoHeight ? 0 : 300;
        if (!open) { SetOpen(id, true); setTimeout(() => SetMounted(id, true), 0) }
        else { SetMounted(id, false); setTimeout(() => SetOpen(id, false), time) }
    }
    const isOpen = (value: string) => {
        const parentValues: string[] = parentValuesDicRef.current[value] || [];
        for (let i = 0; i < parentValues.length; i++) {
            const parentValue = parentValues[i];
            if (openDicRef.current[parentValue] !== true) { return false }
        }
        return openDicRef.current[value] === true
    }
    const isMountedByParentId = (parentId: any) => parentId == undefined ? true : mountedDicRef.current[parentId]
    const getMountClassName = (parentValue: any) => !isMountedByParentId(parentValue) ? ' not-mounted' : ' mounted'
    useEffect(() => {
        if (props.onToggle) { props.onToggle(openDicRef.current) }
    }, [openDic])
    function change(row: any, newRow: any) {
        for (let prop in newRow) { row[prop] = newRow[prop]; }
        if (props.onChange) { props.onChange(props.value) }
    }
    function getChilds(row: any, index: number, level: number): undefined | any[] {
        try {
            if (props.option?.childs) {
                const res = optionsHook.getOptionProp({
                    key: 'childs', optionOrg: row, optionProp: props.option || {},
                    optionDetail: optionsHook.getDefaultoptionDetail({ optionOrg: row, index, rootProps: props as any, def: { level } })
                });
                return res
            }
            else { return row.childs }
        }
        catch { return }
    }
    function setChilds(rowDetails: I_treeRowDetails, childs: undefined | any[]) {
        try {
            if (props.setChilds) { props.setChilds(rowDetails, childs) }
            else { rowDetails.row.childs = childs }
        }
        catch { }
    }
    return {
        toggle, openDic, mountedDic, isOpen, isMountedByParentId, resetParentValuesDic, setParentvalueDic, getMountClassName,
        change, getChilds, setChilds, optionsHook
    }
}
// #endregion
// #region image
const Input_Image: FC = () => {
    const { rootProps } = useProvider();
    function getProps(): AI_Image {
        const props = rootProps;
        return {
            placeholder: props.placeholder,
            deSelect: props.deSelect,
            disabled: props.disabled,
            rtl: props.rtl,
            value: props.value,
            multiple: props.multiple,
            preview: props.preview,
            inputAttrs: props.inputAttrs,
            imageAttrs: props.imageAttrs,
            attrs: props.attrs,
            style: props.style,
            className: props.className,
            onChange: props.onChange
        }
    }
    return <AIImageComponent {...getProps()} />
}
type AI_ImageContext = {
    renderInputFile: (isAddBox?: boolean) => ReactNode,
    getPreviewUrl: () => string,
    urls: string[]
    previewIndex: number,
    changePreviewIndex: (p: { index?: number, dir?: 1 | -1 }) => void,
    renderDeselect: (thumbnailUrl?: string, callback?: () => void) => ReactNode
}
const AIImageContext = createContext<AI_ImageContext>({} as any);
const ImageProvider: FC<{ children: ReactNode, value: AI_ImageContext }> = (p) => <AIImageContext.Provider value={p.value}>{p.children}</AIImageContext.Provider>
const useImageProvider = () => useContext(AIImageContext)
export type AI_Image = {
    placeholder?: ReactNode,
    deSelect?: boolean,
    disabled?: boolean,
    rtl?: boolean,
    value?: any,
    multiple?: boolean,
    preview?: boolean,
    inputAttrs?: any,
    imageAttrs?: any,
    attrs?: any,
    style?: any,
    className?: string,
    onChange?: (urls: any, files: any) => void
}
const AIImageComponent: FC<AI_Image> = (props) => {
    const f = new UT.FileClass()
    const { placeholder = 'placeholder', deSelect = true } = props
    const changable = !!props.onChange && props.disabled !== true;
    const value = fixValue()
    const popup = usePopup({ rtl: props.rtl })
    const editable = !!changable
    const [changeKey, setChangeKey] = useState<number>(0)
    const [previewIndex, setPreviewIndex] = useState<number>(0)
    let [urls, setUrls] = useState<string[]>([]);
    const urlsRef = useRef<string[]>(urls)
    urlsRef.current = urls
    const piRef = useRef<number>(previewIndex)
    piRef.current = previewIndex
    // function placeholdersvg() {
    //     return (
    //         <svg viewBox="0 0 24 24" role="presentation" style={{ width: '100%', height: '100%' }}>
    //             <path d="M14,6L10.25,11L13.1,14.8L11.5,16C9.81,13.75 7,10 7,10L1,18H23L14,6Z" style={{ fill: 'currentcolor' }}></path>
    //         </svg>
    //     )
    // }
    const change = (urls: any, files: any) => { if (props.onChange) { props.onChange(urls, files) } }
    const changePreviewIndex = (p: { index?: number, dir?: 1 | -1 }) => {
        const previewIndex = piRef.current;
        if (p.index !== undefined) { setPreviewIndex(p.index) }
        if (p.dir) {
            let newPreviewIndex = previewIndex + p.dir
            if (newPreviewIndex < 0) { newPreviewIndex = urls.length - 1 }
            if (newPreviewIndex >= urls.length) { newPreviewIndex = 0 }
            setPreviewIndex(newPreviewIndex)
        }
    }
    function fixValue() {
        let { value = [] } = props;
        if (!value || value === null) { value = [] }
        if (!Array.isArray(value)) { value = [value] }
        value = value.filter((v: any) => !!v && v !== null)
        return value
    }
    const add = async (v: any[]) => {
        if (!editable) { return }
        setChangeKey(changeKey + 1)
        if (props.multiple) {
            const newUrls: string[] = [...urls]
            const files: any[] = []
            for (let i = 0; i < v.length; i++) {
                const url = await f.File2Url(v[i]);
                if (newUrls.indexOf(url) === -1) {
                    newUrls.push(url);
                    files.push(v[i])
                }
            }
            change(newUrls, files)
        }
        else {
            const file = v[0];
            const url = await f.File2Url(file);
            change(url, file)
        }
    }
    const remove = async (url: string) => {
        if (!editable) { return }
        setChangeKey(changeKey + 1)
        const newUrls: string[] = urlsRef.current.filter((o) => o !== url)
        if (props.multiple) { change(newUrls, []) }
        else { change(newUrls[0], undefined) }
    }
    let dom: any = createRef()
    useEffect(() => { updateUrls() }, [props.value])
    async function updateUrls() {
        const urls: string[] = []
        for (let i = 0; i < value.length; i++) {
            const url = await f.File2Url(value[i]);
            urls.push(url);
        }
        setUrls(urls)
    }
    function openPreviewPopup(e: any, url: string) {
        e.stopPropagation(); e.preventDefault();
        popup.addModal({
            position: 'center', header: { title: '', onClose: () => popup.removeModal() },
            body: <div className='aio-input-image-preview-popup'><img src={url} width='100%' alt={''} /></div>
        })
    }
    function renderDeselect(thumbnailUrl?: string, callback?: () => void) {
        if (!thumbnailUrl) {
            if (!deSelect || !editable || props.multiple) { return null }
        }
        return (
            <div
                onClick={(e) => { e.stopPropagation(); e.preventDefault(); remove(thumbnailUrl || urls[0]); callback && callback() }}
                className='aio-input-image-button aio-input-image-deSelect'
            >{new UT.GetSvg('em').getIcon('mdiClose', 1)}</div>
        )
    }
    const getPreviewUrl = (): string => urlsRef.current[piRef.current]
    function renderPreviewButton(url: string) {
        if (!props.preview || props.multiple || !editable) { return null }
        return <div onClick={(e) => openPreviewPopup(e, url)} className='aio-input-image-button aio-input-image-preview'>{new UT.GetSvg('em').getIcon('mdiImage', 1)}</div>
    }
    function openMultipleModal(e: any) {
        e.stopPropagation(); e.preventDefault();
        popup.addModal({ position: 'center', header: { title: '', onClose: () => popup.removeModal() }, body: <AIImageMultipleModal /> })
    }
    function renderInputFile(isAddBox?: boolean) {
        if (!editable) { return null }
        if (!isAddBox && props.multiple) { return null }
        return (
            <input
                key={changeKey}
                type='file' multiple={!!isAddBox}
                style={{ width: '100%', height: '100%', padding: 0, display: 'none' }}
                onChange={(e: any) => add(e.target.files)}
                {...props.inputAttrs}
            />
        )
    }
    const renderPreview = () => {
        const imageAttrs = UT.AddToAttrs(props.imageAttrs, { style: { objectFit: 'contain' }, attrs: { ref: dom, width: '100%', ...props.imageAttrs } })
        if (props.multiple) {
            return (
                <UT.AIOSwiper
                    selectedIndex={previewIndex}
                    changeSelectedIndex={(index) => changePreviewIndex({ index })}
                    style={{ height: '100%' }}
                    options={urls}
                    option={{
                        text: (o) => <img {...imageAttrs} src={o} draggable={false} />,
                        onClick: (option, index, e) => {
                            if (option || index) { }
                            openMultipleModal(e)
                        }
                    }}
                />
            )
        }
        return (
            <img
                {...imageAttrs} src={urls[piRef.current]}
                onClick={(e: any) => {
                    if (!editable && !!props.preview) { openPreviewPopup(e, urls[0]) }
                }}
            />
        )
    }
    const renderPlaceholder = () => {
        return (
            <span
                className='aio-input-image-placeholder'
                onClick={(e) => {
                    if (!props.multiple) { return }
                    openMultipleModal(e)
                }}
            >{placeholder}</span>
        )
    }
    const attrs = UT.AddToAttrs(
        props.attrs,
        {
            style: { cursor: !!changable ? 'pointer' : undefined, ...props.style },
            className: ['aio-input aio-input-image', props.className, props.disabled === true ? 'disabled' : undefined]
        }
    )

    return (
        <ImageProvider value={{
            renderInputFile, changePreviewIndex, previewIndex: piRef.current, getPreviewUrl, urls: urlsRef.current, renderDeselect
        }}>
            <label {...attrs}>
                {!urls.length && renderPlaceholder()}
                {!!urls.length && <>{renderPreview()}{renderDeselect()}{renderPreviewButton(urls[0])}</>}
                {renderInputFile()}
            </label>
            {popup.render()}
        </ImageProvider>
    )
}
const AIImageMultipleModal: FC = () => {
    const { renderInputFile, getPreviewUrl, urls, previewIndex, changePreviewIndex, renderDeselect } = useImageProvider()
    const previewUrl = getPreviewUrl()
    const renderThumbnails = () => {
        return (
            <div className="aio-input-image-thubmbnail">
                {
                    urls.map((url, i) => {
                        const active = i === previewIndex
                        return (
                            <div key={i} className={`aio-input-image-modal-body-item${active ? ' active' : ''}`} onClick={() => changePreviewIndex({ index: i })}>
                                <img src={url} alt={''} />
                                {renderDeselect(url, () => changePreviewIndex({ index: 0 }))}
                            </div>
                        )
                    })
                }
            </div>
        )
    }
    return (
        <div className="aio-input-image-modal">
            <div className="aio-input-image-modal-header">
                <label className='aio-input-image-modal-body-item'>{renderInputFile(true)} {new UT.GetSvg('em').getIcon('mdiPlusThick', 1)}</label>
                {renderThumbnails()}
            </div>
            <div className="aio-input-image-modal-preview" style={{ alignItems: previewUrl === undefined ? 'center' : 'flex-start' }}>
                {
                    previewUrl !== undefined &&
                    <UT.AIOSwiper
                        selectedIndex={previewIndex}
                        changeSelectedIndex={(index) => changePreviewIndex({ index })}
                        options={urls}
                        option={{
                            text: (o) => {
                                return <img src={o} alt={''} width='100%' height='100%' style={{ objectFit: 'contain' }} draggable={false} />
                            }
                        }}
                    />
                    // <img src={previewUrl} alt={''} width='100%' height='100%' style={{objectFit:'contain'}} />
                }
                {
                    previewUrl === undefined &&
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10,14.29L6.5,19H17.46L14.75,15.46L12.78,17.8L10,14.29M5,21V7H18.96V21H5M12,2.4L14.61,5.03H9.37L12,2.4M5,5.03C4.5,5.03 4,5.22 3.61,5.61C3.2,6 3,6.46 3,7V21C3,21.5 3.2,22 3.61,22.39C4,22.8 4.5,23 5,23H18.96C19.5,23 19.96,22.8 20.37,22.39C20.77,22 21,21.5 21,21V7C21,6.46 20.77,6 20.37,5.61C19.96,5.22 19.5,5.03 18.96,5.03H16L12,1L7.96,5.03H5Z" />
                    </svg>
                }
            </div>
        </div>
    )
}
// #endregion
// #region calendar
const CalendarWraper: FC<{ onClose?: any }> = ({ onClose }) => {
    const { rootProps } = useProvider()
    function getCalendarProps(): I_Calendar {
        const props = rootProps;
        return {
            type: props.type === 'date' ? 'date' : 'time',
            onClose,
            calendarClose: props.calendarClose,
            onChange: props.onChange || (() => { }),
            dateUnit: props.dateUnit,
            timeUnit: props.timeUnit,
            jalali: props.jalali,
            disabled: props.disabled === true,
            size: props.size,
            theme: props.theme,
            translate: props.translate,
            dateType: props.dateType,
            multiple: props.multiple,
            value: props.value,
            dateAttrs: props.dateAttrs,
            deSelect: props.deSelect,
            now: props.now,
            text: props.text,
            maxLength: props.maxLength
        }
    }
    return <AICalendarComponent {...getCalendarProps()} />
}
type AI_CalendarContext = {
    translate: (text: string) => string, changePopup: (v: ReactNode) => void, DATE: AIODate, rootProps: I_Calendar, changeDate: (newDate: any, clear: boolean) => void,
    today: any, todayWeekDay: any, thisMonthString: any, months: string[], dateUnit: I_AIOInput["dateUnit"], cls: any, activeDateHook: ReturnType<typeof useActiveDate>
}
const CalendarContext = createContext<AI_CalendarContext>({} as any);
const CalendarProvider: FC<{ value: AI_CalendarContext, children: ReactNode }> = ({ value, children }) => {
    return <CalendarContext.Provider value={value}>{children}</CalendarContext.Provider>
}
const useCalendarProvider = () => useContext(CalendarContext)
type AI_dateDetail = {
    dateObject: I_dateObject, dateString: string, dateString2Digit: string, dateArray: number[], dateNumber: number, isoDate: string,
    dateStrings: string[], monthString: string,
    weekDay: string, weekDayIndex: number, months: string[], weekDays: string[], value: any
}
type I_DP_activeDate = { year: number, month: number }
export type I_Calendar = {
    onChange?: (value: any, dateDetails: any) => void,
    onSubmit?: (value: any, dateDetails: any) => void,
    multiple?: boolean, value: any, type: 'date' | 'time', jalali?: boolean, maxLength?: number,
    calendarClose?: boolean, onClose?: () => void, calendarMode?: boolean, dateUnit?: 'year' | 'month' | 'day' | 'hour' | 'minute' | 'second' | 'milisecond', disabled?: boolean,
    size?: number, theme?: string[], translate?: (test: string) => string, text?: ReactNode, pattern?: string,
    dateType?: 'dateNumber' | 'dateString' | 'dateArray' | 'isoDate' | 'dateString2Digit' | 'dateObject',
    dateAttrs?: (p: { dateArray: number[], isToday: boolean, isActive: boolean, isFuture: boolean, weekDay: number, }) => any,
    deSelect?: boolean, now?: boolean, timeUnit?: I_timeUnit, timeStep?: I_timeStep,
}
const AICalendarComponent: FC<I_Calendar> = (props) => {
    const { type = 'date' } = props
    const cls = (key: string) => {
        const a = 'aio-input-date', b = 'aio-input-time'
        return {
            'container': `${a}-container`, 'calendar': `${a}-calendar`, 'popup-container': `${a}-popup-container`, 'today-panel': `${a}-today`,
            'today-label': `${a}-today-label`, 'today-weekday': `${a}-today-weekday`, 'today-day': `${a}-today-day`, 'today-month': `${a}-today-month`,
            'today-year': `${a}-today-year`, 'theme-color': `${a}-theme-color`, 'footer': `${a}-footer`, 'body': `${a}-body`, 'rtl': `${a}-rtl`,
            'ltr': `${a}-ltr`, 'space': `${a}-space`, 'weekday': `${a}-weekday`, 'cell': `${a}-cell`, 'disabled': `${a}-disabled`, 'active': `${a}-active`,
            'theme-active': `${a}-theme-active`, 'theme-border': `${a}-theme-border`, 'today': 'today', 'popup-header': `${a}-popup-header`,
            'popup-label': `${a}-popup-label`, 'popup-footer': `${a}-popup-footer`, 'popup-body': `${a}-popup-body`, 'popup': `${a}-popup`,
            'theme-bg': `${a}-theme-bg`, 'header': `${a}-header`, 'select': `${a}-select`, 'arrow': `${a}-arrow`, 'dropdown': `${a}-dropdown`,
            'time-item': `${b}-popover-item`, 'time-item-title': `${b}-popover-item-title`, 'time-highlight': `${b}-popover-highlight`,
            'time-popover': `${b}-popover`, 'time-popover-body': `${b}-popover-body`, 'time-popover-footer': `${b}-popover-footer`,
        }[key]
    }
    if (type === 'date') { return <DateCalendar {...props} type='date' cls={cls} /> }
    return <TimeCalendar {...props} type='time' cls={cls} />
}
function DateCalendar(props: I_Calendar & { cls: any }) {
    const DATE = new AIODate();
    let { dateUnit = 'day', jalali, disabled, size, theme = [], translate } = props;
    const dateHook = useDate(() => ({ ...props, type: 'date' }))
    let [months] = useState(DATE.getMonths(jalali));
    let [today] = useState(DATE.getToday(jalali))
    let [todayWeekDay] = useState(DATE.getWeekDay(today).weekDay)
    let [thisMonthString] = useState(months[today[1] - 1])
    const [popup, setPopup] = useState<ReactNode>(null)
    let [popupMounted, setPopupMounted] = useState<boolean>(false)
    const activeDateHook = useActiveDate(props)
    function trans(text: string) {
        if (text === 'Today' && dateUnit === 'month') { text = 'This Month' }
        if (translate) { const res = translate(text); if (res) { return res } }
        if (!jalali) { return text }
        return { 'Clear': 'حذف', 'Today': 'امروز', 'This Month': 'ماه جاری', 'Select Year': 'انتخاب سال', 'Close': 'بستن' }[text] || text
    }
    function changePopup(popup: ReactNode) {
        popupMounted = false;
        if (popup === null) { setPopupMounted(false); setTimeout(() => setPopup(null), 300) }
        else { setPopup(popup); setTimeout(() => setPopupMounted(true), 0) }
    }
    function getPopupStyle():any {
        return { fontSize: size, background: theme[1], color: theme[0], stroke: theme[0], cursor: disabled === true ? 'not-allowed' : undefined,direction:props.jalali?'rtl':'ltr' };
    }
    function getContext() {
        let context: AI_CalendarContext = {
            rootProps: props, cls: props.cls,
            activeDateHook, DATE, changePopup, dateUnit,
            translate: trans,
            today, todayWeekDay, thisMonthString, months,
            changeDate: (newDate: any, clear: boolean) => {
                dateHook.changeDate(props.value, newDate, clear);
                if (props.onClose && props.calendarClose) { props.onClose() }
            }
        }
        return context
    }
    return (
        <CalendarProvider value={getContext()}>
            <div className={`${props.cls('container')} ${props.cls('theme-bg')}`} style={{ display: 'flex', fontSize: size }}>
                <div className={props.cls('calendar')} style={getPopupStyle()}><DPHeader /><DPBody /><DPFooter /></div>
                <DPToday />
            </div>
            <div className={`${props.cls('popup-container')} ${popupMounted ? 'mounted' : 'not-mounted'}`}>{popup}</div>
        </CalendarProvider>
    );
}
function DPToday() {
    let { rootProps, translate, today, todayWeekDay, thisMonthString, dateUnit, cls } = useCalendarProvider();
    let { theme = [], jalali } = rootProps;
    return (
        <div className={`${cls('today-panel')} ${cls('theme-active')}`} style={{ color: theme[1], background: theme[0] }}>
            <div className={cls('today-label')}>{translate('Today')}</div>
            {dateUnit !== 'month' && <div className={cls('today-weekday')}>{!jalali ? todayWeekDay.slice(0, 3) : todayWeekDay}</div>}
            {dateUnit !== 'month' && <div className={cls('today-day')}>{today[2]}</div>}
            <div className={cls('today-month')}>{!jalali ? thisMonthString.slice(0, 3) : thisMonthString}</div>
            <div className={cls('today-year')}>{today[0]}</div>
        </div>
    )
}
function DPFooter() {
    let { rootProps, activeDateHook, translate, changeDate, cls } = useCalendarProvider();
    let { disabled, deSelect, now = true, theme = [] } = rootProps;
    if (disabled) { return null }
    return (
        <div className={cls('footer')}>
            {!!deSelect && <button type='button' onClick={() => changeDate(undefined, true)} className={cls('theme-color')}>{translate('Clear')}</button>}
            {!!now && <button type='button' onClick={() => activeDateHook.changeActiveDate('today')} className={cls('theme-color')} style={{ color: theme[0] }}>{translate('Today')}</button>}
        </div>
    )
}
function DPBody() {
    let { rootProps, activeDateHook, dateUnit, cls } = useCalendarProvider();
    return (
        <div className={`${cls('body')} ${cls('body')}-${dateUnit} ${cls(rootProps.jalali ? 'rtl' : 'ltr')}`}>
            {dateUnit === 'day' && <DPBodyDay />}
            {dateUnit === 'month' && UT.GetArray(12, (i) => <DPCell key={'cell' + i} dateArray={[activeDateHook.activeDate.year, i + 1]} />)}
        </div>
    )
}
function DPBodyDay() {
    let { rootProps, activeDateHook, cls } = useCalendarProvider();
    let { theme = [] } = rootProps;
    const { year, month } = activeDateHook.activeDate;
    let { firstWeekDayIndex: fwi, monthDaysLength: mdl, weekDays: wds } = activeDateHook.getDetails();
    return (<>
        {wds.map((weekDay: string, i: number) => <DPCellWeekday key={'weekday' + i} weekDay={weekDay} />)}
        {UT.GetArray(fwi, (i) => <div key={'space' + i} className={`${cls('space')} ${cls('cell')}`} style={{ background: theme[1] }}></div>)}
        {UT.GetArray(mdl, (i) => <DPCell key={'cell' + i} dateArray={[year, month, i + 1]} />)}
        {UT.GetArray(42 - (fwi + mdl), (i) => <div key={'endspace' + i} className={`${cls('space')} ${cls('cell')}`} style={{ background: theme[1] }}></div>)}
    </>)
}
const DPCellWeekday: FC<{ weekDay: string }> = (props) => {
    let { rootProps, translate, cls } = useCalendarProvider();
    let { theme = [], jalali } = rootProps;
    return (
        <div className={`${cls('weekday')} ${cls('cell')} ${cls('theme-color')}`} style={{ background: theme[1], color: theme[0] }}>
            <span>{translate(props.weekDay.slice(0, !jalali ? 2 : 1))}</span>
        </div>
    )
}
function DPCell(props: { dateArray: number[] }) {
    let { rootProps, translate, changeDate, DATE, dateUnit, cls } = useCalendarProvider();
    let { disabled, dateAttrs, theme = [], value, jalali, multiple } = rootProps;
    let { dateArray } = props;
    function IsActive() {
        if (multiple) { return !value.length ? false : !!value.find((o: string) => DATE.isEqual(dateArray, o, dateUnit || 'day')) }
        else { return !value ? false : DATE.isEqual(dateArray, value, dateUnit || 'day'); }
    }
    function getClassName(isActive: boolean, isToday: boolean, isDisabled: boolean, className?: string) {
        var str = cls('cell');
        if (isDisabled) { str += ` ${cls('disabled')}` }
        if (isActive) { str += ` ${cls('active')} ${cls('theme-active')}`; }
        else { str += ` ${cls('theme-color')}`; }
        if (isToday) { str += ` ${cls('today')} ${cls('theme-border')}`; }
        if (className) { str += ` ${className}`; }
        return str;
    }
    let isActive = IsActive();
    let isToday = DATE.isEqual(dateArray, DATE.getToday(jalali), dateUnit || 'day')
    let isFuture = DATE.isGreater(dateArray, DATE.getToday(jalali), dateUnit || 'day')
    let Attrs: any = {}
    if (dateAttrs) {
        let weekDay = 0
        if (dateUnit === 'day') { weekDay = DATE.getWeekDay(dateArray).index }
        Attrs = dateAttrs({ dateArray, isToday, isActive, isFuture, weekDay }) || {}
    }
    let isDisabled = disabled === true || Attrs.disabled === true;
    let className = getClassName(isActive, isToday, isDisabled, Attrs.className);
    let onClick = isDisabled ? undefined : () => { changeDate({ year: dateArray[0], month: dateArray[1], day: dateArray[2] }, false) };
    let style: any = {}
    if (!isDisabled) { style.background = theme[1]; style.color = theme[0] }
    if (className.indexOf(cls('active')) !== -1) { style.background = theme[0]; style.color = theme[1]; }
    if (className.indexOf('today') !== -1) { style.border = `1px solid ${theme[0]}` }
    style = { ...style, ...Attrs.style }
    let text;
    if (dateUnit === 'day') { text = dateArray[2] }
    else if (dateUnit === 'month') {
        let months = DATE.getMonths(jalali);
        text = translate(!jalali ? months[dateArray[1] - 1].slice(0, 3) : months[dateArray[1] - 1])
    }
    return <div style={style} onClick={onClick} className={className}>{isDisabled ? <del>{text}</del> : text}</div>
}
const DPHeaderPopup: FC<{ onClose: () => void, type: 'year' | 'month' }> = (props) => {
    let { rootProps, DATE, translate, activeDateHook, cls } = useCalendarProvider();
    let { jalali, theme = [] } = rootProps;
    const { activeDate, changeActiveDate } = activeDateHook
    let [months] = useState<string[]>(DATE.getMonths(jalali));
    let [start, setStart] = useState<number>(Math.floor(activeDate.year / 10) * 10);
    let [year, setYear] = useState<number>(activeDate.year);
    let [month, setMonth] = useState<number>(activeDate.month);
    useEffect(() => { setYear(activeDate.year); setMonth(activeDate.month) }, [activeDate.year, activeDate.month])
    function changeValue(v: number) {
        if (props.type === 'year') { setYear(v); changeActiveDate({ year: v }); }
        else { setMonth(v); changeActiveDate({ month: v }); }
        props.onClose()
    }
    function changePage(dir: 1 | -1) { setStart(start + (dir * 10)); }
    function getCells() {
        let cells = [];
        const getCls = (active: boolean) => {
            let className = cls('cell')
            if (active) { className += ` ${cls('active')} ${cls('theme-active')}` }
            else { className += ` ${cls('theme-color')}` }
            return className
        }
        if (props.type === 'year') {
            for (let i = start; i < start + 10; i++) {
                let active = i === year;
                let p = { style: active ? { background: theme[0], color: theme[1] } : { background: theme[1], color: theme[0] }, className: getCls(active), onClick: () => changeValue(i) }
                cells.push(<div {...p} key={i}>{i}</div>)
            }
        }
        else {
            for (let i = 1; i <= 12; i++) {
                let active = i === month;
                let p = { style: active ? { background: theme[0], color: theme[1] } : { background: theme[1], color: theme[0] }, className: getCls(active), onClick: () => changeValue(i) }
                let text = months[i - 1]
                if (!jalali) { text = `${text.slice(0, 3)} (${i})` }
                cells.push(<div {...p} key={i}>{text}</div>)
            }
        }
        return cells
    }
    function header_node() {
        if (props.type !== 'year') { return null }
        return (
            <div className={cls('popup-header')}>
                <DPArrow type='minus' onClick={() => changePage(-1)} />
                <div className={cls('popup-label')}>{translate('Select Year')}</div>
                <DPArrow type='plus' onClick={() => changePage(1)} />
            </div>
        )
    }
    function body_node() { return <div className={cls('popup-body')}>{getCells()}</div> }
    function footer_node() {
        return (
            <div className={cls('popup-footer')}>
                <button type='button' className={cls('theme-color')} onClick={() => props.onClose()}>{translate('Close')}</button>
            </div>
        )
    }
    const className = `${cls('popup')} ${cls('theme-bg')} ${cls(jalali ? 'rtl' : 'ltr')}`
    return (<div style={{ background: theme[0], color: theme[1] }} className={className}>{header_node()}{body_node()}{footer_node()}</div>)
}
function DPHeader() {
    let { activeDateHook, cls } = useCalendarProvider();
    const { changeActiveDateByDir } = activeDateHook
    return (
        <div className={cls('header')}>
            <DPArrow type='minus' onClick={() => changeActiveDateByDir(-1)} />
            <div className={cls('select')}><DPHeaderItem type='year' /> <DPHeaderItem type='month' /></div>
            <DPArrow type='plus' onClick={() => changeActiveDateByDir(1)} />
        </div>
    )
}
function DPHeaderItem(props: { type: 'year' | 'month' }) {
    let { dateUnit, cls, rootProps, activeDateHook, months, changePopup } = useCalendarProvider();
    if (props.type === 'month' && dateUnit !== 'day') { return null }
    let { theme = [], jalali } = rootProps;
    const value = activeDateHook.activeDate[props.type]
    if (!value) { return null }
    let text = props.type === 'year' ? value : months[value - 1].substring(0, jalali ? 10 : 3)
    return (
        <button
            type='button' className={`${cls('dropdown')} ${cls('theme-color')}`} style={{ color: theme[0], background: theme[1] }}
            onClick={() => changePopup(<DPHeaderPopup onClose={() => changePopup(null)} type={props.type} />)}
        >{text}</button>
    )
}
const DPArrow: FC<{ type: 'minus' | 'plus', onClick: () => void }> = (props) => {
    let { rootProps, cls } = useCalendarProvider();
    let { theme = [] } = rootProps;
    function getIcon() { return new UT.GetSvg('em').getIcon(props.type === 'minus' ? rootProps.jalali?'mdiChevronLeft':'mdiChevronRight' : rootProps.jalali?'mdiChevronRight':'mdiChevronLeft', 1) }
    return (<div className={`${cls('arrow')} ${cls('theme-color')}`} onClick={props.onClick} style={{ color: theme[1] }}>{getIcon()}</div>)
}
const useActiveDate = (rootProps: I_Calendar) => {
    const DATE = new AIODate();
    const { dateUnit = 'day', jalali, multiple } = rootProps;
    const [activeDate, setActiveDate] = useState<I_DP_activeDate>(getActiveDate);
    const adRef = useRef(activeDate);
    adRef.current = activeDate
    function getActiveDate() {
        const { value } = rootProps;
        let date = multiple ? (value.length ? value[value.length - 1] : undefined) : value;
        date = !date || date === null ? DATE.getToday(jalali) : date;
        let [year, month] = DATE.toArray(date, jalali)
        return { year, month }
    }
    function changeActiveDate(obj: 'today' | { [key in 'year' | 'month']?: number }) {
        if (obj === 'today') { const [year, month] = DATE.getToday(jalali); setActiveDate({ year, month }); }
        else { setActiveDate({ ...adRef.current, ...obj }) }
    }
    function changeActiveDateByDir(dir: -1 | 1) {
        const { year, month } = adRef.current;
        if (dateUnit === 'month') { changeActiveDate({ year: year + dir }) }
        if (dateUnit === 'day') {
            let newYear = year, newMonth = month + dir;
            if (newMonth < 1) { newYear = newYear - 1; newMonth = 12; }
            else if (newMonth > 12) { newYear = newYear + 1; newMonth = 1 }
            changeActiveDate({ year: newYear, month: newMonth })
        }
    }
    function getDetails() {
        const { year, month } = adRef.current;
        const firstWeekDayIndex = DATE.getWeekDay([year, month, 1]).index;
        const monthDaysLength = DATE.getMonthDaysLength([year, month]);
        const weekDays = DATE.getWeekDays(jalali);
        return { firstWeekDayIndex, monthDaysLength, weekDays }
    }
    return { changeActiveDate, activeDate, changeActiveDateByDir, getDetails }
}
export type I_timeUnit = { [key in ('year' | 'month' | 'day' | 'hour' | 'minute' | 'second' | 'milisecond')]?: boolean }
type I_timeStep = { year?: number, month?: number, day?: number, hour?: number, minute?: number, second?: number, milisecond?: number }
const TimeCalendar: FC<I_Calendar & { cls: any }> = (props) => {
    const DATE = new AIODate();
    const { multiple, jalali, size = 12, timeUnit = { year: true, month: true, day: true }, translate: trans, timeStep, cls } = props;
    const dateHook = useDate(() => ({ ...props, type: 'time' }))
    const [activeTime, setActiveTime] = useState<I_dateObject>(getActiveTime)
    const activeTimeRef = useRef<I_dateObject>(activeTime)
    activeTimeRef.current = activeTime
    function getActiveTime(): I_dateObject {
        const { value } = props;
        if (multiple) { return DATE.toObject(DATE.resetByUnit(DATE.getToday(jalali), 'year')) }
        return DATE.toObject(value, jalali)
    }
    const startYearRef = useRef<number | undefined>(activeTimeRef.current.year ? activeTimeRef.current.year - 10 : undefined);
    const endYearRef = useRef<number | undefined>(activeTimeRef.current.year ? activeTimeRef.current.year + 10 : undefined);
    const change = (obj: { [key in keyof I_timeUnit]?: number }) => {
        const newTime = { ...activeTimeRef.current, ...obj }
        setActiveTime(newTime)
    }
    function translate(key: keyof I_timeUnit | 'Submit' | 'Now' | 'Clear') {
        if (trans) { const res = trans(key); if (res !== undefined) { return res } }
        if (!jalali) { return key }
        return { 'Clear': 'حذف', 'year': 'سال', 'month': 'ماه', 'day': 'روز', 'hour': 'ساعت', 'minute': 'دقیقه', 'second': 'ثانیه', 'milisecond': '', 'Submit': 'ثبت', 'Now': 'اکنون' }[key]
    }
    function getTimeOptions(type: keyof I_timeUnit): { text: number, value: number }[] {
        let { year, month, day } = activeTimeRef.current;
        const sy = startYearRef.current, ey = endYearRef.current
        if (type === 'year' && sy && ey) {
            return UT.GetArray(ey - sy + 1, (i) => ({ text: i + sy, value: i + sy }), timeStep?.year)
        }
        if (type === 'day' && day) {
            let length = !year || !month ? 31 : DATE.getMonthDaysLength([year, month]);
            if (day > length) { change({ day: 1 }) }
            return UT.GetArray(length, (i) => { return { text: i + 1, value: i + 1 } }, timeStep?.day)
        }
        if (type === 'month') { return UT.GetArray(12, (i) => ({ text: i + 1, value: i + 1 }), timeStep?.month) }
        return UT.GetArray(type === 'hour' ? 24 : 60, (i) => ({ text: i, value: i }), timeStep ? timeStep[type] : undefined)
    }
    function layout(type: 'year' | 'month' | 'day' | 'hour' | 'minute' | 'second'): ReactNode {
        if (timeUnit[type] !== true) { return null }
        let options = getTimeOptions(type);
        let p: I_AIOInput = { type: 'list', value: activeTimeRef.current[type], options, size: size * 2.5, onChange: (v) => change({ [type]: v }), option: { justify: () => true } }
        return (
            <div className={cls('time-item')}>
                <div className={cls('time-item-title')}>{translate(type)}</div>
                <AIOInput {...p} />
                <div className={cls('time-highlight')}></div>
            </div>
        )
    }
    //function submit() { dateHook.changeDate(props.value, activeTimeRef.current, false); if (props.onClose) { props.onClose(); } }
    function now() { change(DATE.toObject(DATE.getToday(jalali), jalali)) }
    return (
        <div className={cls('time-popover')} style={{ fontSize: size }}>
            <div className={cls('time-popover-body')}>
                {layout('year')} {layout('month')} {layout('day')} {layout('hour')} {layout('minute')} {layout('second')}
            </div>
            <div className={cls('time-popover-footer')}>
                <button type='button' onClick={() => dateHook.changeDate(props.value, activeTimeRef.current, false)} className='aio-input-active-bgcolor'>{translate('Submit')}</button>
                {props.now !== false && <button type='button' onClick={() => now()}>{translate('Now')}</button>}
            </div>
        </div>
    )
}

const useDate = (getProps: () => {
    type: 'date' | 'time',
    jalali?: boolean,
    dateUnit?: I_dateUnit,
    timeUnit?: I_timeUnit,
    multiple?: boolean,
    maxLength?: number,
    disabled?: boolean,
    onChange?: (a: any, b: any) => void,
    text?: ReactNode,
    value?: any,
    placeholder?: ReactNode,
    pattern?: string,
    dateType?: 'dateNumber' | 'dateString' | 'dateArray' | 'isoDate' | 'dateString2Digit' | 'dateObject',
}) => {
    function getDateDetails(value: any): AI_dateDetail {
        const props = getProps();
        const { jalali, dateType = props.type === 'date' ? 'dateString' : 'dateObject' } = props;
        const DATE = new AIODate();
        const dateObject = DATE.toObject(value, jalali)
        const { year, month, day, hour, minute, second, milisecond } = dateObject;
        const dateArray: number[] = [year, month, day, hour, minute, second, milisecond]
        const dateString = getDateString(value);
        const dateString2Digit = getDateString(value, true);
        const dateNumber = DATE.getTime(dateArray)
        const isoDate = DATE.toIsoDate(dateArray)
        const dateStrings: string[] = [year.toString(), UT.Get2Digit(month), UT.Get2Digit(day), UT.Get2Digit(hour), UT.Get2Digit(minute), UT.Get2Digit(second), milisecond.toString(),]
        const monthString = DATE.getMonths(jalali)[month - 1];
        const { weekDay, index: weekDayIndex } = DATE.getWeekDay(dateArray)
        const weekDays = DATE.getWeekDays(jalali)
        const months = DATE.getMonths(jalali)
        let v: any = dateObject
        if (dateType === 'dateNumber') { v = dateNumber }
        else if (dateType === 'dateArray') { v = dateArray }
        else if (dateType === 'dateString') { v = dateString }
        else if (dateType === 'dateString2Digit') { v = dateString2Digit }
        else if (dateType === 'isoDate') { v = isoDate }
        return { dateObject, dateArray, dateString: dateString as any, dateString2Digit: dateString2Digit as any, dateNumber, isoDate, dateStrings, monthString, weekDay, weekDayIndex, value: v, weekDays, months };
    }
    function getDateString(value?: I_dateObject, twoDigit?: boolean): ReactNode {
        if (!value) { return '' }
        const props = getProps();
        const { jalali, type, dateUnit = 'day', timeUnit = { year: true, month: true, day: true } } = props;
        const dateObject = new AIODate().toObject(value, jalali)
        const values: { year?: number, month?: number, day?: number, hour?: number, minute?: number, second?: number, milisecond?: number } = {}
        if (type === 'date') {
            values.year = dateObject.year
            values.month = dateObject.month
            values.day = dateUnit === 'day' ? dateObject.day : undefined
        }
        else {
            values.year = timeUnit.year === true ? dateObject.year : undefined
            values.month = timeUnit.month === true ? dateObject.month : undefined
            values.day = timeUnit.day === true ? dateObject.day : undefined
            values.hour = timeUnit.hour === true ? dateObject.hour : undefined
            values.minute = timeUnit.minute === true ? dateObject.minute : undefined
            values.second = timeUnit.second === true ? dateObject.second : undefined
        }
        let text = [], dateArray = [], timeArray = []
        const dateItems: ['year', 'month', 'day'] = ['year', 'month', 'day']
        for (let i = 0; i < dateItems.length; i++) {
            const v = values[dateItems[i]];
            if (v !== undefined) { dateArray.push(twoDigit ? UT.Get2Digit(v) : v) }
        }
        if (dateArray.length) { text.push(dateArray.join('/')) }
        const timeItems: ['hour', 'minute', 'second'] = ['hour', 'minute', 'second']
        for (let i = 0; i < timeItems.length; i++) {
            const v = values[timeItems[i]];
            if (v !== undefined) { timeArray.push(twoDigit ? UT.Get2Digit(v) : v) }
        }
        if (timeArray.length) { text.push(timeArray.join(':')) }
        return text.join(' ');
    }
    function getDateText(value?: I_dateObject, twoDigit?: boolean): ReactNode {
        const { text, placeholder = '', pattern, jalali } = getProps();
        if (text) { return text }
        if (!value) { return placeholder || '' }
        if (pattern) { return new AIODate().getDateByPattern(value, pattern, jalali) }
        return getDateString(value, twoDigit)
    }
    function changeDate(oldValue: any, newDate: any, clear: boolean) {
        const { onChange, disabled, jalali, multiple, maxLength } = getProps();
        const changable = !!onChange && disabled !== true
        if (!changable) { return }
        const DATE = new AIODate()
        if (clear) {
            if (multiple) { onChange([], []) }
            else { onChange(undefined, undefined) }
            return
        }
        const dateDetails = getDateDetails(DATE.toObject(newDate, jalali))
        if (multiple) {
            let newValue: number[] = [];
            if (oldValue) {
                if (!Array.isArray(oldValue)) { newValue = [oldValue] }
                else { newValue = oldValue }
            }
            else { newValue = [] }
            let index = newValue.findIndex((o) => DATE.getTime(o) === dateDetails.dateNumber);
            if (index === -1) { newValue = [...newValue, dateDetails.value] }
            else { newValue = newValue.filter((o: number, i) => !!o && i !== index) }
            if (maxLength) {
                while (newValue.length > maxLength) {
                    newValue = newValue.slice(1, newValue.length)
                }
            }
            const details = [], res = []
            for (let i = 0; i < newValue.length; i++) {
                const obj = getDateDetails(newValue[i])
                details.push(obj);
                res.push(obj.value)
            }
            onChange(res, details);
        }
        else { onChange(dateDetails.value, dateDetails); }
    }
    return { getDateDetails, getDateText, changeDate }
}
export type I_MonthCalendar = { date: number[], onClick?: (date: number[]) => void, dateAttrs?: (date: number[]) => any }
export const MonthCalendar: FC<I_MonthCalendar> = ({ date, onClick = () => { }, dateAttrs = () => ({}) }) => {
    const DATE = new AIODate();
    const [jalali] = useState<boolean>(DATE.isJalali(date));
    const [monthStrings] = useState<string[]>(DATE.getMonths(jalali))
    const [firstDayIndex] = useState<number>(DATE.getWeekDay([date[0], date[1], 1]).index);
    const [monthDaysLength] = useState<number>(DATE.getMonthDaysLength(date))
    function weekDays_layout() { return DATE.getWeekDays(true).map((o) => <div className="month-calendar-weekday">{o[0]}</div>) }
    function spaces_layout() { return new Array(firstDayIndex).fill(0).map(() => <div className=""></div>) }
    function cells_layout() {
        return new Array(monthDaysLength).fill(0).map((o: number, i: number) => {
            if (o) { }
            return cell_layout([date[0], date[1], i + 1])
        })
    }
    function cell_layout(dateArray: number[]) {
        const attrs = UT.AddToAttrs(dateAttrs(dateArray), { className: `month-calendar-day`, attrs: { onClick: () => onClick(dateArray) } })
        return (<div {...attrs}>{dateArray[2]}</div>)
    }
    return (
        <div className="month-calendar">
            <div className="month-calendar-title">{monthStrings[date[1] - 1]}</div>
            <div className="month-calendar-weekdays">{weekDays_layout()}</div>
            <div className="month-calendar-days">{spaces_layout()} {cells_layout()}</div>
        </div>
    )
}
// #endregion
// #region list
export type I_list_temp = {
    dom: any, activeIndex: number, interval: any, moved: boolean, lastY: number, deltaY: number,
    so: { y: number, top: number, newTop?: number, limit: { top: number, bottom: number } }
}
const List: FC = () => {
    let { rootProps, optionDetails, AIChange } = useProvider();
    let { attrs = {}, size = 36, listOptions = { count: 3, editable: true, stop: 3, decay: 8 } } = rootProps;
    let { count = 3, editable = true, stop = 3, decay = 8 } = listOptions;
    let optionsLength: number = optionDetails.list.length
    let [temp] = useState<I_list_temp>({
        dom: createRef(),
        activeIndex: 0,
        interval: undefined,
        moved: false,
        lastY: 0,
        deltaY: 0,
        so: { y: 0, top: 0, limit: { top: 0, bottom: 0 } }
    })
    function getStyle() {
        var height = count * (size);
        return { height }
    }
    function getIndexByTop(top: number) { return Math.round(((count * size) - size - (2 * top)) / (2 * size)); }
    function getTopByIndex(index: number) { return (count - 2 * index - 1) * size / 2; }
    function getContainerStyle() { return { top: getTopByIndex(temp.activeIndex) }; }
    function moveDown(e: any) {
        e.preventDefault()
        if (temp.activeIndex >= optionsLength - 1) { return }
        temp.activeIndex++;
        let newTop = getTopByIndex(temp.activeIndex);
        setStyle({ top: newTop });
        setBoldStyle(temp.activeIndex);
    }
    function setBoldStyle(index: number) {
        $(temp.dom.current).find('.aio-input-list-option').removeClass('active');
        $(temp.dom.current).find('.aio-input-list-option[data-index=' + (index) + ']').addClass('active');
    }
    function moveUp() {
        if (temp.activeIndex <= 0) { return }
        temp.activeIndex--;
        let newTop = getTopByIndex(temp.activeIndex);
        setStyle({ top: newTop });
        setBoldStyle(temp.activeIndex);
    }
    function keyDown(e: any) {
        if (!editable) { return }
        if (e.keyCode === 38) { moveUp(); }
        else if (e.keyCode === 40) { moveDown(e); }
    }
    function getLimit() { return { top: getTopByIndex(-1), bottom: getTopByIndex(optionsLength) } }
    function getTrueTop(top: number) {
        let index = getIndexByTop(top);
        if (index < 0) { index = 0 }
        if (index > optionsLength - 1) { index = optionsLength - 1 }
        return getTopByIndex(index);
    }
    function mouseDown(e: any) {
        if (!editable) { return }
        UT.EventHandler('window', 'mousemove', mouseMove, 'bind');
        UT.EventHandler('window', 'mouseup', mouseUp, 'bind');
        clearInterval(temp.interval);
        temp.moved = false;
        let client = UT.GetClient(e);
        let y = client.y
        setStyle({ transition: 'unset' });
        let top = getTop();
        var index = getIndexByTop(top);
        setBoldStyle(index);
        setStyle({ top, transition: 'unset' });
        AIChange(optionDetails.list[index].value, index)
        temp.so = { y, top, limit: getLimit() };
    }
    function getTop() {
        var top = parseInt($(temp.dom.current).find('.aio-input-list-options').css('top'));
        return getTrueTop(top);
    }
    function fixTop(value: number) {
        let { top, bottom } = temp.so.limit;
        if (value > top) { return top }
        if (value < bottom) { return bottom }
        return value;
    }
    function mouseMove(e: any) {
        e.preventDefault()
        e.stopPropagation()
        temp.moved = true;
        var client = UT.GetClient(e);
        let y = client.y;
        var offset = y - temp.so.y;
        if (temp.lastY === undefined) { temp.lastY = y }
        temp.deltaY = y - temp.lastY;
        temp.lastY = y;
        if (Math.abs(offset) < 20) { temp.deltaY = 3 }
        var newTop = fixTop(temp.so.top + offset);
        let index = getIndexByTop(newTop);
        temp.so.newTop = newTop;
        setBoldStyle(index);
        setStyle({ top: newTop });
    }
    function setStyle(obj: any) { $(temp.dom.current).find('.aio-input-list-options').css(obj); }
    function mouseUp() {
        UT.EventHandler('window', 'mousemove', mouseMove, 'unbind');
        UT.EventHandler('window', 'mouseup', mouseUp, 'unbind');
        if (!temp.moved) { return }
        temp.moved = false;
        move(temp.deltaY, temp.so.newTop)
    }
    function move(deltaY: number, startTop = getTop()) {
        if (decay < 0) { decay = 0 }
        if (decay > 99) { decay = 99 }
        decay = 1 + decay / 1000;
        temp.interval = setInterval(() => {
            startTop += deltaY;
            let index = getIndexByTop(startTop);
            setBoldStyle(index);
            if (Math.abs(deltaY) < stop || index < 0 || index > optionsLength - 1) {
                clearInterval(temp.interval);
                if (index < 0) { index = 0 }
                if (index > optionsLength - 1) { index = optionsLength - 1 }
                let top = getTopByIndex(index);
                setStyle({ top, transition: '0.3s' });
                const optionDetail = optionDetails.list[index]
                AIChange(optionDetail.value, optionDetail)
                return;
            }
            deltaY /= decay;
            setStyle({ top: startTop });
        }, 20)
    }
    useEffect(() => { if (rootProps.listOptions?.move) { rootProps.listOptions.move(move) } }, [])
    useEffect(() => {
        setBoldStyle(temp.activeIndex);
    })
    let fixedOptions = optionDetails.list.map((o: AI_optionDetail, i: number) => {
        if (o.value === rootProps.value) { temp.activeIndex = i; }
        return (<AILayout key={i} optionDetail={o} />)
    });
    return (
        <div
            {...attrs} ref={temp.dom} tabIndex={0} onKeyDown={(e) => keyDown(e)}
            className={'aio-input-list' + (attrs.className ? ' ' + attrs.className : '')}
            style={{ ...attrs.style, ...getStyle() }}
        >
            <div
                className='aio-input-list-options' style={getContainerStyle()}
                onMouseDown={(e) => mouseDown(e)} onTouchStart={(e) => mouseDown(e)}
            >{fixedOptions}</div>
        </div>
    );
}
// #endregion
// #region file
const FileIcon: FC<{ file: any }> = ({ file }) => {
    const fRef = useRef<UT.FileClass>(new UT.FileClass())
    const f = fRef.current
    const getPreview = (file: File) => {
        if (file.type.startsWith("image/")) { return <img src={f.FileToSrc(file)} />; }
        if (file.type.startsWith("video/")) {
            return (
                <video style={{ height: '100%' }}
                    src={f.FileToSrc(file)}
                    onLoadedData={(e) => ((e.target as HTMLVideoElement).currentTime = 10)}
                />
            );
        }
        return new UT.GetSvg('em').getFileIcon(file, 2)
    };
    if (f.IsFile(file)) { return <div className="aio-input-file-item-icon">{getPreview(file as File)}</div>; }
    return (<div className="aio-input-file-item-icon cursor-pointer" onClick={() => f.download(file)}>{new UT.GetSvg('em').getIcon("mdiAttachment", 2)}</div>);
};

function InputFile() {
    let { rootProps, types, AIChange } = useProvider();
    let { value = [], disabled, inputAttrs } = rootProps;
    function change(e: any) {
        let Files: FileList = e.target.files;
        let result;
        if (types.isMultiple) {
            value = value || []
            result = [...value];
            let names = result.map(({ name }) => name);
            for (let i = 0; i < Files.length; i++) {
                let file: File = Files[i];
                if (names.indexOf(file.name) !== -1) { continue }
                result.push(file)
            }
            if (rootProps.maxLength) {
                while (result.length > rootProps.maxLength) {
                    result = result.slice(1, result.length)
                }
            }
        }
        else {
            if (Files.length) { result = Files[0] }
            else { return }
        }
        AIChange(result, undefined)
    }
    let props = { disabled: disabled === true, type: 'file', style: { display: 'none' }, multiple: types.isMultiple, onChange: (e: any) => change(e), ...inputAttrs }
    return <input {...props} />
}
// #endregion
// #region option
const Options: FC = () => {
    let { rootProps, types, optionDetails, isDraggable, optionClick, keyboardNavHook } = useProvider();
    const getList = () => {
        const list = optionDetails.list
        if (!searchValue) { return list }
        return list.filter((optionDetail: AI_optionDetail) => {
            if (optionDetail.text === undefined || optionDetail.text === '' || optionDetail.text === null) { return false }
            if ((optionDetail.text as string).indexOf(searchValue) === -1) { return false }
            return true
        });
    }
    let [searchValue, setSearchValue] = useState('');
    let [dom] = useState<any>(createRef())
    const hasSearch = rootProps.type !== 'tabs' && rootProps.type !== 'buttons' && !types.isInput && !!rootProps.search
    const getPlaceholder = () => {
        const text = rootProps.optionsPlaceholder || 'There is not any items';
        return (
            <div className="aio-input-options-placeholder">{text}</div>
        )
    }
    function getRenderOptions() {
        const list = getList()
        if (!list.length) { return getPlaceholder() }
        if (isDraggable()) { return getDraggableOptions(list) }
        return list.map((optionDetail: AI_optionDetail, i) => {
            if (!!rootProps.search && searchValue) {
                if (optionDetail.text === undefined || optionDetail.text === '' || optionDetail.text === null) { return null }
                if ((optionDetail.text as string).indexOf(searchValue) === -1) { return null }
            }
            return <AILayout optionDetail={optionDetail} key={i} />
        });
    }
    function getDraggableOptions(list: AI_optionDetail[]) {
        return (
            <UT.DragAndDrop<AI_optionDetail>
                data={list}
                getId={(optionDetail) => optionDetail.value}
                getContent={(optionDetail, { id }) => {
                    if (!!rootProps.search && searchValue) {
                        if (optionDetail.text === undefined || optionDetail.text === '' || optionDetail.text === null) { return null }
                        if ((optionDetail.text as string).indexOf(searchValue) === -1) { return null }
                    }
                    return <AILayout optionDetail={optionDetail} key={id} />
                }}
                onChange={(newOptions, fromIndex, toIndex) => (rootProps.onSwap as any)(newOptions.map((o) => o.optionOrg), fromIndex, toIndex)}
            />
        )
    }
    useEffect(() => { try { if (!types.hasKeyboard) { setTimeout(() => $(dom.current).focus(), 30); } } catch { } }, [])
    const keyDown = (e: any) => {
        const code = e.keyCode;
        console.log(types)
        if (code === 13) {
            const f = keyboardNavHook.getFocusedOptionDetail();
            if (!f) { return }
            optionClick(f)
        }
        else if (types.isDropdown || types.isRootOptions) {
            const { rtl } = rootProps;
            let dir = 0
            if (code === 37) { dir = rtl ? 1 : -1 }
            else if (code === 39) { dir = rtl ? -1 : 1 }
            else if (code === 38) { dir = -1 }
            else if (code === 40) { dir = 1 }
            if (dir === 1 || dir === -1) {
                e.preventDefault();
                keyboardNavHook.optionNextFocus(dir)
            }
        }
    }
    if (!optionDetails.list.length) { return null }
    let renderOptions = getRenderOptions();
    const attrs = UT.AddToAttrs(
        rootProps.optionsAttrs, {
        className: [
            'aio-input-options',
            'ai-border-radius-md',
            'aio-input-focus',
            `aio-input-${rootProps.type}-options`,
            types.isDropdown ? 'aio-input-dropdown-options' : undefined,
            !types.isDropdown && rootProps.justify ? 'aio-input-options-justify' : undefined
        ],
        attrs: {
            ref: dom,
            tabIndex: 1,
            onKeyDown: (e: any) => keyDown(e)
        }
    })
    return (
        <div {...attrs}>
            {
                !!hasSearch &&
                <AIText
                    value={searchValue}
                    className='aio-input-search'
                    onChange={(searchValue) => setSearchValue(searchValue)}
                    placeholder={rootProps.search}
                    before={new UT.GetSvg('em').getIcon('mdiMagnify', 0.8)}
                    deSelect={true}
                />
            }
            {renderOptions}
        </div>
    )
}

export type AI_optionDetail = {
    value: any, optionOrg: any, rootProps: I_AIOInput,
    index: number, isFirstChild: boolean, isLastChild: boolean,
    show: any, checked?: boolean, checkIcon: ReactNode[],
    text: ReactNode, subtext: ReactNode, after: ReactNode, before: ReactNode,
    justify: boolean, disabled: boolean, attrs: any, className: string, style: any,
    toggleIcon: false | { close?: ReactNode, open?: ReactNode, leaf?: ReactNode }, isOpen: () => boolean, toggle: () => void, change: (newRow: any) => void, level: number,
    tagAttrs: any, tagBefore: any, tagAfter: any, tagText: any, tagSubtext: any,
    onClick?: (optionOrg: any, optionDetail: AI_optionDetail) => void,
    close?: boolean,
    active: boolean,
    childs?: any[],
    body: ReactNode,
    parentOptions: AI_optionDetail[]
}
export const useOptions = () => {
    function getOptions(p: {
        rootProps: I_AIOInput,
        optionOrgs: any[],
        level?: number,
        optionProp: AI_optionProp,
        isOpen?: (value: any) => boolean,
        change?: (row: any, newRow: any) => void,
        toggle?: (p: { row: any, index: number, level: number, value: any, state?: boolean }) => void,
        parentOptions?: AI_optionDetail[],
        getChilds?: (row: any, index: number, level: number) => any | undefined
    }): AI_optionDetails {
        let { optionOrgs, rootProps, level = 0, optionProp, isOpen, parentOptions } = p;
        //const typesRef = useRef<AI_types>(getTypes(rootProps));
        const types = getTypes(rootProps)
        if (types.isDate) {
            const { text = (o) => o.dateString } = optionProp;
            optionProp = { ...optionProp, text, value: (o) => o.dateString }
        }
        let list = [];
        let dic: AI_optionDetails['dic'] = {}
        function getDefaultOptionChecked(v: any) {
            if (types.isMultiple) {
                const { value = [] } = rootProps;
                if (rootProps.type === 'select' || rootProps.type === 'radio') { return value.indexOf(v) !== -1 }
            }
            else {
                if (rootProps.type === 'radio') { 
                    if(v === undefined){return false}
                    return rootProps.value === v 
                }
            }
        }
        function isActive(optionValue: any): boolean {
            if (types.isMultiple) {
                const { value = [] } = rootProps;
                if (!value.length) { return false }
                return (rootProps.value || []).indexOf(optionValue) !== -1
            }
            else { return optionValue === rootProps.value && rootProps.value !== undefined }
        }
        for (let i = 0; i < optionOrgs.length; i++) {
            let optionOrg = optionOrgs[i];
            const optionDetail = getDefaultoptionDetail({ rootProps, optionOrg, index: i, def: { level, isOpen, rootProps } })
            optionDetail.value = getOptionProp({ type: rootProps.type, optionProp, optionOrg, optionDetail, key: 'value' })
            optionDetail.disabled = !!rootProps.disabled || !!getOptionProp({ type: rootProps.type, optionProp, optionOrg, optionDetail, key: 'disabled' });
            optionDetail.text = getOptionProp({ type: rootProps.type, optionProp, optionOrg, optionDetail, key: 'text' });
            let show = getOptionProp({ type: rootProps.type, optionProp, optionOrg, optionDetail, key: 'show' })
            if (show === false) { continue }
            optionDetail.isOpen = () => !isOpen ? true : isOpen(optionDetail.value)
            optionDetail.change = (newRow: any) => {
                if (!p.change) { return }
                p.change(optionOrg, newRow)
            }
            optionDetail.toggle = (state?: boolean) => {
                if (!p.toggle) { return }
                p.toggle({ row: optionDetail.optionOrg, index: i, level: optionDetail.level, value: optionDetail.value, state })
            }
            optionDetail.childs = !p.getChilds ? undefined : p.getChilds(optionOrg, i, level)
            optionDetail.active = isActive(optionDetail.value);
            optionDetail.attrs = getOptionProp({ type: rootProps.type, optionProp, optionOrg, optionDetail, key: 'attrs', def: {} });
            let defaultChecked = getDefaultOptionChecked(optionDetail.value)
            optionDetail.checked = getOptionProp({ type: rootProps.type, optionProp, optionOrg, optionDetail, key: 'checked', def: defaultChecked })
            optionDetail.checkIcon = getOptionProp({ type: rootProps.type, optionProp, optionOrg, optionDetail, key: 'checkIcon' })
            optionDetail.before = getOptionProp({ type: rootProps.type, optionProp, optionOrg, optionDetail, key: 'before' })
            optionDetail.after = getOptionProp({ type: rootProps.type, optionProp, optionOrg, optionDetail, key: 'after' })
            optionDetail.justify = getOptionProp({ type: rootProps.type, optionProp, optionOrg, optionDetail, key: 'justify' })
            optionDetail.subtext = getOptionProp({ type: rootProps.type, optionProp, optionOrg, optionDetail, key: 'subtext' })
            optionDetail.onClick = getOptionProp({ type: rootProps.type, optionProp, optionOrg, optionDetail, key: 'onClick', preventFunction: true })
            optionDetail.className = getOptionProp({ type: rootProps.type, optionProp, optionOrg, optionDetail, key: 'className' })
            optionDetail.style = getOptionProp({ type: rootProps.type, optionProp, optionOrg, optionDetail, key: 'style' })
            optionDetail.toggleIcon = getOptionProp({ type: rootProps.type, optionProp, optionOrg, optionDetail, key: 'toggleIcon' })
            optionDetail.tagAttrs = getOptionProp({ type: rootProps.type, optionProp, optionOrg, optionDetail, key: 'tagAttrs' })
            optionDetail.tagBefore = getOptionProp({ type: rootProps.type, optionProp, optionOrg, optionDetail, key: 'tagBefore' })
            optionDetail.tagAfter = getOptionProp({ type: rootProps.type, optionProp, optionOrg, optionDetail, key: 'tagAfter' })
            optionDetail.tagText = getOptionProp({ type: rootProps.type, optionProp, optionOrg, optionDetail, key: 'tagText' })
            optionDetail.tagSubtext = getOptionProp({ type: rootProps.type, optionProp, optionOrg, optionDetail, key: 'tagSubtext' })
            optionDetail.body = getOptionProp({ type: rootProps.type, optionProp, optionOrg, optionDetail, key: 'body', def: null })
            optionDetail.close = getOptionProp({ type: rootProps.type, optionProp, optionOrg, optionDetail, key: 'close', def: !types.isMultiple })
            optionDetail.parentOptions = parentOptions || []
            list.push(optionDetail)
            dic['a' + optionDetail.value] = optionDetail;
        }
        if (list.length) {
            list[0].isFirstChild = true;
            list[list.length - 1].isLastChild = true
        }
        return { list, dic };
    }
    function getOptionProp(p: {
        key: keyof AI_optionDetail,
        def?: any,
        preventFunction?: boolean,
        optionDetail: AI_optionDetail,
        optionProp: AI_optionProp,
        optionOrg: any,
        type?: any
    }) {
        let { optionProp, key, def, preventFunction, optionDetail, optionOrg } = p;
        const prop = optionProp[key];
        if (prop) {
            if (!preventFunction) {
                let res = prop(optionOrg, optionDetail);
                return res === undefined ? def : res;
            }
            else { return () => prop(optionOrg, optionDetail); }

        }
        const optionResult = getOptionResult(optionOrg, key, optionDetail, preventFunction)
        if (optionResult !== undefined) { return optionResult }

        return prop !== undefined ? prop : def;
    }
    function getOptionResult(optionOrg: any, key: keyof AI_optionDetail, optionDetail: AI_optionDetail, preventFunction?: boolean) {
        if (optionOrg === null || optionOrg === undefined) { return }
        try {
            if (typeof optionOrg[key] === 'function' && !preventFunction) {
                return optionOrg[key](optionOrg, optionDetail)
            }
            else { return optionOrg[key] }
        }
        catch { }
    }
    function getDefaultoptionDetail(p: { rootProps: I_AIOInput, optionOrg: any, index: number, def?: { [key in keyof AI_optionDetail]?: any } }) {
        const { optionOrg, index, def, rootProps } = p;
        const optionDetail: AI_optionDetail = {
            rootProps, optionOrg, index, isFirstChild: false, isLastChild: false, active: false, toggleIcon: null, isOpen: () => false, toggle: () => { }, change: () => { },
            tagText: '', tagSubtext: '', body: null,
            show: true, after: null, before: null, subtext: null, justify: false, checkIcon: undefined, parentOptions: [],
            text: null, disabled: false, attrs: {}, className: '', style: {}, level: 0, tagAttrs: {}, tagAfter: null, tagBefore: null, value: undefined,
            ...def
        }
        return optionDetail
    }
    return { getOptions, getOptionProp, getDefaultoptionDetail }
}
// #endregion
// #region suggestion
const SuggestionInput = (props: AI<'text', any>) => {
    const o = useOptions()
    const { value = '', option: optionProp = {}, fetchSuggestions, onChange = () => { }, options: optionOrgs = [] } = props;
    const [options, setOptions] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [search, setSearch] = useState<string>(value);
    const fetchOptions = async (search: string) => {
        let res: any[] = []
        if (!fetchSuggestions) {
            if (!search) {
                res = optionOrgs || []
            }
            else {
                const { list } = o.getOptions({ rootProps: { ...props, type: 'text' }, optionOrgs, optionProp })
                res = list.filter((o) => {
                    const text = typeof o.text === 'string' ? o.text : ''
                    return text.indexOf(search) !== -1
                }).map((o) => o.optionOrg)
            }
        }
        else {
            setLoading(true)
            res = await fetchSuggestions(search);
            setLoading(false)
        }
        setOptions(res)
        return res
    }
    const changeSearch = (search: string | undefined) => {
        setSearch(search || '');
        fetchOptions(search || '')
        onChange(search || '')
    }
    const changeOption = (optionDetail: AI_optionDetail) => {
        const text = optionDetail.text as string
        setSearch(text);
        onChange(text, optionDetail)
    }
    useEffect(() => {
        fetchOptions(value)
    }, [])
    useEffect(() => {
        changeSearch(props.value)
    }, [props.value])
    return (
        <AIText
            after={loading ? new UT.GetSvg('em').getIcon('mdiLoading', 0.8, { spin: 0.3 }) : undefined}
            {...props}
            value={search} options={options}
            option={{ ...optionProp, onClick: (_, optionDetail) => changeOption(optionDetail) }}
            onChange={(v) => changeSearch(v)}
            isSuggestion={true}
            fetchSuggestions={undefined}
        />
    )
}
// #endregion
export const Signature: React.FC<{
    attrs?: React.HTMLAttributes<HTMLCanvasElement>;
    size?: number, fa?: boolean,
    onSubmit?: (p: { file: any, base64: string | ArrayBuffer | null }) => void;
}> = ({ attrs = {}, onSubmit, size }) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const ctxRef = useRef<CanvasRenderingContext2D | null>(null);
    const [drawing, setDrawing] = useState(false);

    useEffect(() => {
        const canvas = canvasRef.current!;
        canvas.width = canvas.offsetWidth;
        canvas.height = canvas.offsetHeight;
        const ctx = canvas.getContext('2d');
        if (ctx) {
            ctx.lineCap = 'round';
            ctx.lineWidth = 2;
            ctx.strokeStyle = '#000';
            ctxRef.current = ctx;
        }
    }, []);

    const getPos = (e: MouseEvent | TouchEvent) => {
        const canvas = canvasRef.current!;
        const rect = canvas.getBoundingClientRect();

        if ('touches' in e) {
            const t = e.touches[0];
            return { x: t.clientX - rect.left, y: t.clientY - rect.top };
        }

        return { x: (e as MouseEvent).clientX - rect.left, y: (e as MouseEvent).clientY - rect.top };
    };
    const startDraw = (e: React.MouseEvent | React.TouchEvent) => {
        e.preventDefault();
        const pos = getPos(e.nativeEvent);
        ctxRef.current?.beginPath();
        ctxRef.current?.moveTo(pos.x, pos.y);
        setDrawing(true);
    };

    const draw = (e: React.MouseEvent | React.TouchEvent) => {
        if (!drawing) return;
        const pos = getPos(e.nativeEvent);
        ctxRef.current?.lineTo(pos.x, pos.y);
        ctxRef.current?.stroke();
    };

    const endDraw = () => {
        setDrawing(false);
        ctxRef.current?.closePath();
    };
    const clear = () => {
        const canvas = canvasRef.current!;
        ctxRef.current?.clearRect(0, 0, canvas.width, canvas.height);
    };

    const save = () => {
        const canvas = canvasRef.current!;
        canvas.toBlob(async (blob) => {
            if (blob && onSubmit) {
                const file: any = new (File as any)([blob], 'signature.png', { type: 'image/png' });
                const fs = new UT.FileClass()
                const base64 = await fs.FileToBase64(file)
                onSubmit({ file, base64 });
            }
        }, 'image/png');
    };
    const Attrs = UT.AddToAttrs(attrs, { className: 'ai-signature', style: { width: size, height: size } })
    return (
        <div {...Attrs}>
            <canvas
                ref={canvasRef}
                onMouseDown={startDraw}
                onMouseMove={draw}
                onMouseUp={endDraw}
                onMouseLeave={endDraw}
                onTouchStart={startDraw}
                onTouchMove={draw}
                onTouchEnd={endDraw}
            />
            <div className='ai-signature-footer'>
                <button type='button' className='ai-signature-save' onClick={save}>ذخیره</button>
                <button type='button' className='ai-signature-clear' onClick={clear}>پاک کردن</button>
            </div>
        </div>
    );
};
export const Pattern: FC<{ size?: number, count?: number, onSubmit: (v: string) => void, pointColor?: string, lineColor?: string, backgroundColor?: string }> = ({ size = 72, onSubmit, pointColor = '#0069ff', lineColor = '#0069ff', backgroundColor = '#333', count = 3 }) => {
    const canvas = useCanvas()
    const [points, setPoints] = useState<number[][]>([])
    const [startPos, setStartPos] = useState<number[] | false>(false)
    const [usedIndexes, setUsedIndexes] = useState<number[]>([])
    const uiRef = useRef<number[]>(usedIndexes)
    uiRef.current = usedIndexes
    const [mousePos, setMousePos] = useState<number[] | false>(false)
    const getDot = (x: number, y: number): I_canvas_item => {
        return { type: 'Arc', x, y, r: size / 8, fill: pointColor }
    }
    const mouseUp = () => {
        UT.EventHandler('window', "mouseup", mouseUp, 'unbind');
        reset(true)
    }
    const reset = (submit?: boolean) => {
        const usedIndexes = uiRef.current;
        if (submit && usedIndexes.length) {
            const code = usedIndexes.join('')
            onSubmit(code)
        }
        setStartPos(false);
        setUsedIndexes([]);
        setPoints([])
    }
    const getClickArea = (x: number, y: number, index: number): I_canvas_item => {
        return {
            type: 'Arc', x, y, r: size / 3, fill: 'rgba(0,0,0,0)',
            events: {
                onMouseDown: () => {
                    UT.EventHandler('window', "mouseup", mouseUp)
                    setStartPos([x, y, index])
                    setPoints([[x, y]])
                },
                onMouseEnter: () => {
                    if (!startPos) { return }
                    if (usedIndexes.indexOf(index) !== -1) { return }
                    setStartPos([x, y, index])
                    setPoints((prev) => [...prev, [x, y]])
                    setUsedIndexes((prev) => {
                        const newUsedIndexes = [...prev, index]
                        if (newUsedIndexes.length > count * count) {
                            return newUsedIndexes.slice(0, count * count)
                        }
                        else {
                            return newUsedIndexes;
                        }
                    })
                }
            }
        }
    }
    const getMouseLine = (): I_canvas_item[] => {
        if (startPos === false || mousePos === false) { return [] }
        return [{
            type: 'Line', points: [[startPos[0], startPos[1]], mousePos], lineWidth: size / 12, stroke: lineColor
        }]
    }
    const getPointsLine = (): I_canvas_item[] => {
        if (points.length < 2) { return [] }
        return [{
            type: 'Line', points, lineWidth: size / 12, stroke: lineColor
        }]
    }
    const getDots = (): I_canvas_item[] => {
        const dots: I_canvas_item[] = []
        const start = size / 2;
        let index = -1;
        for (let i = 0; i < count; i++) {
            for (let j = 0; j < count; j++) {
                const x = j * size + start, y = i * size + start;
                index++;
                dots.push(getDot(x, y), getClickArea(x, y, index))
            }
        }
        return dots
    }
    return (
        <>{canvas.render({
            screenPosition: ['50%', '50%'],
            attrs: { className: 'aio-pattern', style: { width: size * count, height: size * count, background: backgroundColor } },
            items: [...getDots(), ...getMouseLine(), ...getPointsLine()],
            onMouseMove: (_, mp) => {
                const { x, y } = mp;
                setMousePos([x, y])
            },
        })}</>
    )
}
function PlaySound(state: boolean) {
    const success = new Audio(successSound); // آدرس فایل اول
    const error = new Audio(errorSound); // آدرس فایل دوم

    if (state) {
        success.play();
    } else {
        error.play();
    }
}

type I_CardsLayout_option = {
    before?: (item: any, index: number) => ReactNode,
    after?: (item: any, index: number) => ReactNode,
    subtext?: (item: any, index: number) => ReactNode,
    text?: (item: any, index: number) => ReactNode,
    onClick?: (item: any, index: number) => void,
    html?: (item: any, index: number) => ReactNode
}
type I_CardsLayout = {
    attrs?: any,
    header?: ReactNode, headerAttrs?: any,
    body?: ReactNode, bodyAttrs?: any,
    footer?: ReactNode, footerAttrs?: any,
    list?: { items: any[], option: I_CardsLayout_option }
}
export const Cards: FC<I_CardsLayout> = ({ header, body, footer, list, headerAttrs, footerAttrs, bodyAttrs, attrs }) => {
    const HeaderAttrs = UT.AddToAttrs(headerAttrs, { className: "cards-layout-header" })
    const FooterAttrs = UT.AddToAttrs(footerAttrs, { className: "cards-layout-footer" })
    const BodyAttrs = UT.AddToAttrs(bodyAttrs, { className: "cards-layout-body" })
    return (
        <div {...UT.AddToAttrs(attrs, { className: 'cards-layout' })}>
            {!!header && <div {...HeaderAttrs}>{header}</div>}
            <div {...BodyAttrs}>
                {!!body && body}
                {!!list && list.items.map((item, i) => <Card key={i} option={list.option} item={item} index={i} />)}
            </div>
            {!!footer && <div {...FooterAttrs}>{footer}</div>}
        </div>
    )
}

export const Card: FC<{ option: I_CardsLayout_option, item: any, index: number }> = ({ option, item, index }) => {
    const getByOption = (option: I_CardsLayout_option, field: keyof I_CardsLayout_option, item: any) => option[field] ? option[field](item, index) : undefined
    const html = getByOption(option, 'html', item)
    if (html !== undefined) { return html as any }
    const before = getByOption(option, 'before', item)
    const after = getByOption(option, 'after', item)
    const subtext = getByOption(option, 'subtext', item)
    const text = getByOption(option, 'text', item)
    return (
        <div className="cards-layout-item" onClick={option.onClick ? () => (option as any).onClick(item, index) : undefined}>
            {before !== undefined && <div className="cards-layout-item-before">{before as any}</div>}
            <div className={`cards-layout-item-center${subtext !== undefined ? ' has-subtext' : ''}`}>
                {text as any}
                {subtext !== undefined && <div className="cards-layout-item-subtext">{subtext as any}</div>}
            </div>
            {after !== undefined && <div className="cards-layout-item-after">{after as any}</div>}
        </div>
    )
}

type I_calcOp = '+' | '-' | '*' | '/' | '-%' | '+%'
const Calc: FC<{ number: number, onSubmit: (result: number) => void }> = ({ number, onSubmit }) => {
    const [value, setValue] = useState<string>('');
    const [op, setOp] = useState<I_calcOp>('+')
    const getRow = (start: number) => {
        const cls = "calc-row calc-gap"
        if (start === 0) { return (<div className={cls} key={0}>{getKey('clear')}{getKey(0)}{getKey('space')}</div>) }
        return (<div className={cls} key={start}>{UT.GetArray(3).map((o) => getKey(start + o))}</div>)
    }
    const getKey = (num: number | 'space' | 'clear') => {
        const cls = 'calc-key calc-active'
        if (num === 'space') { return <div className={cls}></div> }
        if (num === 'clear') { return <div onClick={() => setValue('')} className={cls}>C</div> }
        return <div key={num} className={cls} onClick={() => changeValue(num)}>{num}</div>
    }
    const changeValue = (num: number) => {
        let res = value;
        res += num;
        if (res.length > 1) {
            if (res[0] === '0') { res = res.slice(1, res.length) }
        }
        setValue(res)
    }
    const getByPercent = (number: number, percent: number) => Math.round(percent * number / 100)
    const getResult = () => {
        const num = +value;
        if (isNaN(num)) { return '' }
        if (op === '+') { return number + num }
        if (op === '-') { return number - num }
        if (op === '*') { return number * num }
        if (op === '/') { return number / num }
        if (op === '-%') { return number - getByPercent(number, num) }
        if (op === '+%') { return number + getByPercent(number, num) }
        return ''
    }
    const close = () => $('#calc-backdrop').remove()
    const submit = () => { onSubmit(result || 0); close() }
    const result = getResult()
    return (
        <div className="calc-modal" style={{ direction: 'ltr' }} onClick={(e) => e.stopPropagation()}>
            <div className="calc-header">
                <div className="calc-close calc-active" onClick={() => close()}>{new UT.GetSvg('em').getIcon('mdiClose', 0.8)}</div>
                <div className="msf" style={{ flex: 1 }}></div>
                ماشین حساب
            </div>
            <AIButtons
                options={['+', '-', '*', '/', '-%', '+%']}
                option={{
                    text: (o) => o,
                    value: (o) => o,
                    style: () => ({ flex: 1, height: '3em', flexShrink: 0 }),
                    justify: () => true,
                    className: () => 'calc-border calc-active'
                }}
                value={op}
                onChange={(v) => setOp(v)}
            />
            <div className="calc-keys calc-gap">{getRow(1)}{getRow(4)}{getRow(7)}{getRow(0)}</div>
            <div className="calc-flex-row">
                <div className="calc-box calc-border">{UT.SplitNumber(number)}</div>
                <div className="calc-op">{op}</div>
                <div className="calc-box calc-border">{UT.SplitNumber(value)}</div>
            </div>
            <div className="calc-flex-row">
                <div className="calc-box calc-border">
                    <div className="calc-equal">=</div>
                    {UT.SplitNumber(result)}
                </div>
            </div>
            <div className="calc-footer">
                <button className='calc-submit calc-active' onClick={() => submit()}>تایید</button>
                <button className='calc-close calc-active' onClick={() => close()}>بستن</button>
            </div>

        </div>
    )
}


export const TextList: FC = () => {
    const { rootProps } = useProvider()
    const { onChange = (() => { }), value = [], text = '', option = {} } = rootProps;
    const add = () => onChange([...value, ''])
    const remove = (index: number) => onChange(value.filter((_: string, i: number) => i !== index))
    const change = (index: number, v: string) => onChange(value.map((o: string, i: number) => i === index ? v : o))
    return (
        <div className="aio-input-textlist">
            <div className="aio-input-textlist-header">
                <div style={{ flex: 1 }}>{text}</div>
                <div className="aio-input-textlist-add" onClick={add}>{new UT.GetSvg('em').getIcon('mdiPlusThick', .8)}</div>
            </div>
            <div className="aio-input-textlist-items">
                {
                    value.map((o: string, i: number) => {
                        const { attrs = (() => { }), style = (() => { }), className = (() => ''), before = (() => null) } = option
                        const optionDetail = { index: i }
                        const Attrs = attrs(o, optionDetail as any), Style = style(o, optionDetail as any), ClassName = className(o, optionDetail as any), Before = before(o, optionDetail as any)
                        const finalAttrs = UT.AddToAttrs(Attrs, { className: ClassName, style: Style })
                        return (
                            <AIText
                                key={i} attrs={finalAttrs} value={o} onChange={(value) => change(i, value)} before={Before}
                                after={(
                                    <div className='aio-input-textlist-item-after'>
                                        {!!o && <div onClick={() => change(i, '')}>{new UT.GetSvg('em').getIcon('mdiClose', .8)}</div>}
                                        <div onClick={() => remove(i)}>{new UT.GetSvg('em').getIcon('mdiDelete', .8)}</div>
                                    </div>
                                )}
                            />
                        )
                    })
                }
            </div>
        </div>
    )
}

export const Scanner: FC<{
    onScan: (text: string) => Promise<boolean | string>;
    onClose: () => void;
    fps: number;
    style?: any
}> = ({ onScan, onClose, fps, style }) => {
    const popup = usePopup()
    const timeoutRef = useRef<any>(undefined)
    const videoRef = useRef<HTMLVideoElement>(null);
    const readerRef = useRef<BrowserMultiFormatReader | null>(null);
    const scanningRef = useRef(false);
    const controlsRef = useRef<IScannerControls | null>(null);
    const [resultColor, setResultColor] = useState<string>('rgba(0,0,0,0)')
    const changeResultColor = (color: string) => {
        setResultColor(color);
        clearTimeout(timeoutRef.current);
        setTimeout(() => { setResultColor('rgba(0,0,0,0)') }, 1000)
    }
    const close = () => { controlsRef.current?.stop(); onClose() }
    const submit = async (result: Result | undefined) => {
        if (result && !scanningRef.current) {
            scanningRef.current = true;
            const barcode = result.getText()
            const res = await onScan(barcode);
            if (res === true) {
                changeResultColor('#05ca1f')
            }
            else {
                if (typeof res === 'string') {
                    popup.addSnackebar({
                        type: 'error',
                        text: res,
                        subtext: barcode
                    })
                }
                changeResultColor('red')
            }
            setTimeout(() => { scanningRef.current = false; }, 300)
        }
    }
    useEffect(() => {
        const reader = new BrowserMultiFormatReader(undefined, { delayBetweenScanAttempts: 1000 / fps });
        readerRef.current = reader;
        reader.decodeFromVideoDevice(undefined, videoRef.current!, (result: Result | undefined) => {
            submit(result)
        }).then((controls) => { controlsRef.current = controls; }).catch((err) => { console.error("خطا در راه‌اندازی دوربین:", err); });
        return () => { controlsRef.current?.stop() }
    }, []);
    return (
        <div style={{ width: "80vw", height: "80vh", padding: 12, position: 'relative', overflow: 'hidden', ...style }}>
            <video ref={videoRef} style={{ width: "100%", height: "100%", objectFit: "cover", boxShadow: `0 0 12px 6px ${resultColor}` }} />
            <div className="scanner-close" onClick={close}>
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{ fill: 'currentColor' }}>
                    <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                </svg>
            </div>
            {popup.render()}
        </div>
    );
};

type I_timelineDay = {
    weekday: string,
    day: number,
    month: number,
    date: number[]
}

export const Timeline: FC<{ date: number[], onChange: (newDate: number[]) => void }> = ({ date, onChange }) => {
    const DATE = new AIODate()
    function getDays() {
        return [getDay(-48), getDay(-24), getDay(0), getDay(24), getDay(48)]
    }
    function getDay(offset: number): I_timelineDay {
        const newDate = offset === 0 ? date : DATE.getNextTime(date, offset * 60 * 60 * 1000);
        const day = newDate[2]
        const month = newDate[1]
        const weekday = DATE.getWeekDay(newDate).weekDay
        return { weekday, day, month, date: newDate }
    }
    return (
        <div className="timeline">
            {getDays().map((day, i) => <TimelineItem key={i} day={day} active={i === 2} onClick={() => onChange(day.date)} />)}
        </div>
    )
}
const TimelineItem: FC<{ day: I_timelineDay, active: boolean, onClick: () => void }> = ({ day, active, onClick }) => {
    const DATE = new AIODate()
    return (
        <div className={`timeline-item${active ? ' active' : ''}`} onClick={onClick}>
            <div className="timeline-item-day">{day.day}</div>
            <div className="timeline-item-weekday">{day.weekday}</div>
            <div className="timeline-item-month">{DATE.getMonths(true)[day.month - 1]}</div>
        </div>
    )
}
const useKeyboardNav = (p: { getContainer: () => any, getOptionDetails: () => AI_optionDetails, rootProps: I_AIOInput }) => {
    function getOptionDom(optionDetail: AI_optionDetail) {
        const container = p.getContainer();
        if (!container || container === null) { return false }
        const res = $(container).find(`.aio-input-option[data-index=${optionDetail.index}]`)
        try { return res[0] || false }
        catch { return false }
    }
    function optionFocus(optionDetail: AI_optionDetail) {
        try {
            const res = getOptionDom(optionDetail)
            if (!res) { return }
            res.focus();
        }
        catch { }
    }
    function getFocusedOptionDetail(): false | AI_optionDetail {
        const container = p.getContainer();
        if (!container || container === null) return false;
        const active = document.activeElement;
        if (!(active instanceof HTMLElement)) return false;
        if (!container.contains(active)) return false;
        const option = active.classList.contains('aio-input-option') ? active : active.closest('.aio-input-option') as HTMLElement | null;
        if (!option || option === null) return false;
        const indexAttr = option.getAttribute('data-index');
        if (indexAttr === null) return false;
        const index = Number(indexAttr);
        if (Number.isNaN(index)) { return false }
        const { list } = p.getOptionDetails()
        if (!Array.isArray(list)) { return false }
        const optionDetail = list[index]
        return optionDetail || false
    }
    function getNextOption(optionDetail: AI_optionDetail, dir: 1 | -1) {
        const { list } = p.getOptionDetails()
        if (!Array.isArray(list)) { return }
        const currentIndex = !!optionDetail ? optionDetail.index : (dir === 1 ? -1 : list.length)
        for (let i = 1; i <= list.length; i++) {
            const nextIndex = (currentIndex + (i * dir) + list.length) % list.length;
            const option = list[nextIndex];

            if (!option.disabled && option.show !== false) {
                return option;
            }
        }
        return undefined;
    }
    function optionNextFocus(dir: -1 | 1) {
        let next;
        let f = getFocusedOptionDetail()
        if (!f) {
            const { list } = p.getOptionDetails();
            if (!list.length) { return }
            next = list[0]
        }
        else { next = getNextOption(f, dir) }
        if (!next) { return }
        optionFocus(next)
    }
    return { optionNextFocus, getFocusedOptionDetail }
}

export const IRPlate:FC<{value:string[],attrs?:any}> = ({value,attrs})=>{
    const Attrs = UT.AddToAttrs(attrs,{className:"ir-plate"})
    return (
        <div {...Attrs}>
            <div className="ir-plate-item">
                <div className="msf">{value[0]}</div>
                <div className="msf">{value[1]}</div>
                <div className="msf">{value[2]}</div>
            </div>
            <div className="ir-plate-number">{value[3]}</div>
        </div>
    )
}
// const [recognition, setRecognition] = useState<any>()
// useEffect(() => {
//     if (!('webkitSpeechRecognition' in window)) { return }
//     let { voice } = rootProps;
//     if (!voice || !changable || !types.hasKeyboard) { return }
//     // @ts-ignore
//     const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
//     if (!SpeechRecognition) { return }
//     const recognition = new SpeechRecognition();
//     recognition.lang = { en: 'en-US', fa: 'fa-IR' }[voice];
//     recognition.continuous = true;
//     recognition.interimResults = false;
//     recognition.onresult = (event: any) => {
//         const result = event.results[0][0].transcript;
//         AIChange(result, undefined);
//     };
//     recognition.onerror = (event: any) => {
//         console.error('خطا در تشخیص گفتار: ', event.error);
//     };
//     recognition.onend = () => {
//         console.log('تشخیص گفتار پایان یافت.');
//     };
//     setRecognition(recognition)
//     return () => { recognition.stop(); };
// }, []);
// function startVoice() {
//     recognition.start();
// }
// function voice() {
//     if (!recognition) { return null }
//     return <div className='aio-input-voice' onClick={() => startVoice()}>{I('mdiMicrophoneOutline', 0.8)}</div>
// }